import { j as jsxRuntimeExports, c as clientExports } from "./chunk.client_v20251016.js";
import { r as reactExports, R as React } from "./chunk.headless_v20251016.js";
import "./chunk.react_v20251016.js";
function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = /* @__PURE__ */ ((cache) => (thing) => {
  const str = toString.call(thing);
  return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null));
const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type;
};
const typeOfTest = (type) => (thing) => typeof thing === type;
const { isArray } = Array;
const isUndefined = typeOfTest("undefined");
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(val) {
  let result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}
const isString = typeOfTest("string");
const isFunction = typeOfTest("function");
const isNumber = typeOfTest("number");
const isObject = (thing) => thing !== null && typeof thing === "object";
const isBoolean = (thing) => thing === true || thing === false;
const isPlainObject = (val) => {
  if (kindOf(val) !== "object") {
    return false;
  }
  const prototype2 = getPrototypeOf(val);
  return (prototype2 === null || prototype2 === Object.prototype || Object.getPrototypeOf(prototype2) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
const isDate = kindOfTest("Date");
const isFile = kindOfTest("File");
const isBlob = kindOfTest("Blob");
const isFileList = kindOfTest("FileList");
const isStream = (val) => isObject(val) && isFunction(val.pipe);
const isFormData = (thing) => {
  let kind;
  return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === "formdata" || // detect form-data instance
  kind === "object" && isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
const isURLSearchParams = kindOfTest("URLSearchParams");
const [isReadableStream, isRequest, isResponse, isHeaders] = ["ReadableStream", "Request", "Response", "Headers"].map(kindOfTest);
const trim = (str) => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(obj, fn, { allOwnKeys = false } = {}) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  let i;
  let l;
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;
    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}
function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}
const _global = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
})();
const isContextDefined = (context) => !isUndefined(context) && context !== _global;
function merge() {
  const { caseless } = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };
  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}
const extend = (a, b, thisArg, { allOwnKeys } = {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, { allOwnKeys });
  return a;
};
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
};
const inherits = (constructor, superConstructor, props, descriptors2) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors2);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, "super", {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};
const toFlatObject = (sourceObj, destObj, filter2, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};
  destObj = destObj || {};
  if (sourceObj == null) return destObj;
  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter2 !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter2 || filter2(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
};
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === void 0 || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};
const isTypedArray = /* @__PURE__ */ ((TypedArray) => {
  return (thing) => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];
  const iterator = generator.call(obj);
  let result;
  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];
  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }
  return arr;
};
const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str) => {
  return str.toLowerCase().replace(
    /[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};
const hasOwnProperty = (({ hasOwnProperty: hasOwnProperty2 }) => (obj, prop) => hasOwnProperty2.call(obj, prop))(Object.prototype);
const isRegExp = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer) => {
  const descriptors2 = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};
  forEach(descriptors2, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });
  Object.defineProperties(obj, reducedDescriptors);
};
const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    if (isFunction(obj) && ["arguments", "caller", "callee"].indexOf(name) !== -1) {
      return false;
    }
    const value = obj[name];
    if (!isFunction(value)) return;
    descriptor.enumerable = false;
    if ("writable" in descriptor) {
      descriptor.writable = false;
      return;
    }
    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error("Can not rewrite read-only method '" + name + "'");
      };
    }
  });
};
const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};
  const define = (arr) => {
    arr.forEach((value) => {
      obj[value] = true;
    });
  };
  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
  return obj;
};
const noop = () => {
};
const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const ALPHA = "abcdefghijklmnopqrstuvwxyz";
const DIGIT = "0123456789";
const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = "";
  const { length } = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length | 0];
  }
  return str;
};
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const toJSONObject = (obj) => {
  const stack = new Array(10);
  const visit = (source, i) => {
    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }
      if (!("toJSON" in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};
        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });
        stack[i] = void 0;
        return target;
      }
    }
    return source;
  };
  return visit(obj, 0);
};
const isAsyncFn = kindOfTest("AsyncFunction");
const isThenable = (thing) => thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }
  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({ source, data }) => {
      if (source === _global && data === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);
    return (cb) => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    };
  })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
})(
  typeof setImmediate === "function",
  isFunction(_global.postMessage)
);
const asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind(_global) : typeof process !== "undefined" && process.nextTick || _setImmediate;
const utils$1 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap
};
function AxiosError$1(message, code, config, request, response) {
  Error.call(this);
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = new Error().stack;
  }
  this.message = message;
  this.name = "AxiosError";
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  if (response) {
    this.response = response;
    this.status = response.status ? response.status : null;
  }
}
utils$1.inherits(AxiosError$1, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const prototype$1 = AxiosError$1.prototype;
const descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((code) => {
  descriptors[code] = { value: code };
});
Object.defineProperties(AxiosError$1, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: true });
AxiosError$1.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);
  utils$1.toFlatObject(error, axiosError, function filter2(obj) {
    return obj !== Error.prototype;
  }, (prop) => {
    return prop !== "isAxiosError";
  });
  AxiosError$1.call(axiosError, error.message, code, config, request, response);
  axiosError.cause = error;
  axiosError.name = error.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};
const httpAdapter = null;
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}
function removeBrackets(key) {
  return utils$1.endsWith(key, "[]") ? key.slice(0, -2) : key;
}
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    token = removeBrackets(token);
    return !dots && i ? "[" + token + "]" : token;
  }).join(dots ? "." : "");
}
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}
const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});
function toFormData$1(obj, formData, options) {
  if (!utils$1.isObject(obj)) {
    throw new TypeError("target must be an object");
  }
  formData = formData || new FormData();
  options = utils$1.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    return !utils$1.isUndefined(source[option]);
  });
  const metaTokens = options.metaTokens;
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
  const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);
  if (!utils$1.isFunction(visitor)) {
    throw new TypeError("visitor must be a function");
  }
  function convertValue(value) {
    if (value === null) return "";
    if (utils$1.isDate(value)) {
      return value.toISOString();
    }
    if (!useBlob && utils$1.isBlob(value)) {
      throw new AxiosError$1("Blob is not supported. Use a Buffer instead.");
    }
    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return useBlob && typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
    }
    return value;
  }
  function defaultVisitor(value, key, path) {
    let arr = value;
    if (value && !path && typeof value === "object") {
      if (utils$1.endsWith(key, "{}")) {
        key = metaTokens ? key : key.slice(0, -2);
        value = JSON.stringify(value);
      } else if (utils$1.isArray(value) && isFlatArray(value) || (utils$1.isFileList(value) || utils$1.endsWith(key, "[]")) && (arr = utils$1.toArray(value))) {
        key = removeBrackets(key);
        arr.forEach(function each(el, index) {
          !(utils$1.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : indexes === null ? key : key + "[]",
            convertValue(el)
          );
        });
        return false;
      }
    }
    if (isVisitable(value)) {
      return true;
    }
    formData.append(renderKey(path, key, dots), convertValue(value));
    return false;
  }
  const stack = [];
  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });
  function build(value, path) {
    if (utils$1.isUndefined(value)) return;
    if (stack.indexOf(value) !== -1) {
      throw Error("Circular reference detected in " + path.join("."));
    }
    stack.push(value);
    utils$1.forEach(value, function each(el, key) {
      const result = !(utils$1.isUndefined(el) || el === null) && visitor.call(
        formData,
        el,
        utils$1.isString(key) ? key.trim() : key,
        path,
        exposedHelpers
      );
      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });
    stack.pop();
  }
  if (!utils$1.isObject(obj)) {
    throw new TypeError("data must be an object");
  }
  build(obj);
  return formData;
}
function encode$1(str) {
  const charMap = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}
function AxiosURLSearchParams(params, options) {
  this._pairs = [];
  params && toFormData$1(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};
prototype.toString = function toString2(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;
  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + "=" + _encode(pair[1]);
  }, "").join("&");
};
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(url, params, options) {
  if (!params) {
    return url;
  }
  const _encode = options && options.encode || encode;
  if (utils$1.isFunction(options)) {
    options = {
      serialize: options
    };
  }
  const serializeFn = options && options.serialize;
  let serializedParams;
  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils$1.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams(params, options).toString(_encode);
  }
  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils$1.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}
const transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
const URLSearchParams$1 = typeof URLSearchParams !== "undefined" ? URLSearchParams : AxiosURLSearchParams;
const FormData$1 = typeof FormData !== "undefined" ? FormData : null;
const Blob$1 = typeof Blob !== "undefined" ? Blob : null;
const platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
const _navigator = typeof navigator === "object" && navigator || void 0;
const hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || ["ReactNative", "NativeScript", "NS"].indexOf(_navigator.product) < 0);
const hasStandardBrowserWebWorkerEnv = (() => {
  return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
  self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const origin = hasBrowserEnv && window.location.href || "http://localhost";
const utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserEnv,
  hasStandardBrowserWebWorkerEnv,
  navigator: _navigator,
  origin
}, Symbol.toStringTag, { value: "Module" }));
const platform = {
  ...utils,
  ...platform$1
};
function toURLEncodedForm(data, options) {
  return toFormData$1(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils$1.isBuffer(value)) {
        this.append(key, value.toString("base64"));
        return false;
      }
      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}
function parsePropPath(name) {
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name).map((match) => {
    return match[0] === "[]" ? "" : match[1] || match[0];
  });
}
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    if (name === "__proto__") return true;
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils$1.isArray(target) ? target.length : name;
    if (isLast) {
      if (utils$1.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }
      return !isNumericKey;
    }
    if (!target[name] || !utils$1.isObject(target[name])) {
      target[name] = [];
    }
    const result = buildPath(path, value, target[name], index);
    if (result && utils$1.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }
    return !isNumericKey;
  }
  if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};
    utils$1.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });
    return obj;
  }
  return null;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || "";
    const hasJSONContentType = contentType.indexOf("application/json") > -1;
    const isObjectPayload = utils$1.isObject(data);
    if (isObjectPayload && utils$1.isHTMLForm(data)) {
      data = new FormData(data);
    }
    const isFormData2 = utils$1.isFormData(data);
    if (isFormData2) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }
    if (utils$1.isArrayBuffer(data) || utils$1.isBuffer(data) || utils$1.isStream(data) || utils$1.isFile(data) || utils$1.isBlob(data) || utils$1.isReadableStream(data)) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
      return data.toString();
    }
    let isFileList2;
    if (isObjectPayload) {
      if (contentType.indexOf("application/x-www-form-urlencoded") > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }
      if ((isFileList2 = utils$1.isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
        const _FormData = this.env && this.env.FormData;
        return toFormData$1(
          isFileList2 ? { "files[]": data } : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }
    if (isObjectPayload || hasJSONContentType) {
      headers.setContentType("application/json", false);
      return stringifySafely(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    const transitional2 = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    const JSONRequested = this.responseType === "json";
    if (utils$1.isResponse(data) || utils$1.isReadableStream(data)) {
      return data;
    }
    if (data && utils$1.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
      const silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === "SyntaxError") {
            throw AxiosError$1.from(e, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }
    return data;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1.forEach(["delete", "get", "head", "post", "put", "patch"], (method) => {
  defaults.headers[method] = {};
});
const ignoreDuplicateOf = utils$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]);
const parseHeaders = (rawHeaders) => {
  const parsed = {};
  let key;
  let val;
  let i;
  rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
    i = line.indexOf(":");
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();
    if (!key || parsed[key] && ignoreDuplicateOf[key]) {
      return;
    }
    if (key === "set-cookie") {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    }
  });
  return parsed;
};
const $internals = Symbol("internals");
function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }
  return utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
  const tokens = /* @__PURE__ */ Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;
  while (match = tokensRE.exec(str)) {
    tokens[match[1]] = match[2];
  }
  return tokens;
}
const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter2, isHeaderNameFilter) {
  if (utils$1.isFunction(filter2)) {
    return filter2.call(this, value, header);
  }
  if (isHeaderNameFilter) {
    value = header;
  }
  if (!utils$1.isString(value)) return;
  if (utils$1.isString(filter2)) {
    return value.indexOf(filter2) !== -1;
  }
  if (utils$1.isRegExp(filter2)) {
    return filter2.test(value);
  }
}
function formatHeader(header) {
  return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
    return char.toUpperCase() + str;
  });
}
function buildAccessors(obj, header) {
  const accessorName = utils$1.toCamelCase(" " + header);
  ["get", "set", "has"].forEach((methodName) => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}
let AxiosHeaders$1 = class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }
  set(header, valueOrRewrite, rewrite) {
    const self2 = this;
    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);
      if (!lHeader) {
        throw new Error("header name must be a non-empty string");
      }
      const key = utils$1.findKey(self2, lHeader);
      if (!key || self2[key] === void 0 || _rewrite === true || _rewrite === void 0 && self2[key] !== false) {
        self2[key || _header] = normalizeValue(_value);
      }
    }
    const setHeaders = (headers, _rewrite) => utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));
    if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if (utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils$1.isHeaders(header)) {
      for (const [key, value] of header.entries()) {
        setHeader(value, key, rewrite);
      }
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }
    return this;
  }
  get(header, parser) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils$1.findKey(this, header);
      if (key) {
        const value = this[key];
        if (!parser) {
          return value;
        }
        if (parser === true) {
          return parseTokens(value);
        }
        if (utils$1.isFunction(parser)) {
          return parser.call(this, value, key);
        }
        if (utils$1.isRegExp(parser)) {
          return parser.exec(value);
        }
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(header, matcher) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils$1.findKey(this, header);
      return !!(key && this[key] !== void 0 && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }
    return false;
  }
  delete(header, matcher) {
    const self2 = this;
    let deleted = false;
    function deleteHeader(_header) {
      _header = normalizeHeader(_header);
      if (_header) {
        const key = utils$1.findKey(self2, _header);
        if (key && (!matcher || matchHeaderValue(self2, self2[key], key, matcher))) {
          delete self2[key];
          deleted = true;
        }
      }
    }
    if (utils$1.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }
    return deleted;
  }
  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;
    while (i--) {
      const key = keys[i];
      if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }
    return deleted;
  }
  normalize(format) {
    const self2 = this;
    const headers = {};
    utils$1.forEach(this, (value, header) => {
      const key = utils$1.findKey(headers, header);
      if (key) {
        self2[key] = normalizeValue(value);
        delete self2[header];
        return;
      }
      const normalized = format ? formatHeader(header) : String(header).trim();
      if (normalized !== header) {
        delete self2[header];
      }
      self2[normalized] = normalizeValue(value);
      headers[normalized] = true;
    });
    return this;
  }
  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }
  toJSON(asStrings) {
    const obj = /* @__PURE__ */ Object.create(null);
    utils$1.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(", ") : value);
    });
    return obj;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ": " + value).join("\n");
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }
  static concat(first, ...targets) {
    const computed = new this(first);
    targets.forEach((target) => computed.set(target));
    return computed;
  }
  static accessor(header) {
    const internals = this[$internals] = this[$internals] = {
      accessors: {}
    };
    const accessors = internals.accessors;
    const prototype2 = this.prototype;
    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);
      if (!accessors[lHeader]) {
        buildAccessors(prototype2, _header);
        accessors[lHeader] = true;
      }
    }
    utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
    return this;
  }
};
AxiosHeaders$1.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1.reduceDescriptors(AxiosHeaders$1.prototype, ({ value }, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1);
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  };
});
utils$1.freezeMethods(AxiosHeaders$1);
function transformData(fns, response) {
  const config = this || defaults;
  const context = response || config;
  const headers = AxiosHeaders$1.from(context.headers);
  let data = context.data;
  utils$1.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : void 0);
  });
  headers.normalize();
  return data;
}
function isCancel$1(value) {
  return !!(value && value.__CANCEL__);
}
function CanceledError$1(message, config, request) {
  AxiosError$1.call(this, message == null ? "canceled" : message, AxiosError$1.ERR_CANCELED, config, request);
  this.name = "CanceledError";
}
utils$1.inherits(CanceledError$1, AxiosError$1, {
  __CANCEL__: true
});
function settle(resolve, reject, response) {
  const validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError$1(
      "Request failed with status code " + response.status,
      [AxiosError$1.ERR_BAD_REQUEST, AxiosError$1.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}
function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || "";
}
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;
  min = min !== void 0 ? min : 1e3;
  return function push(chunkLength) {
    const now = Date.now();
    const startedAt = timestamps[tail];
    if (!firstSampleTS) {
      firstSampleTS = now;
    }
    bytes[head] = chunkLength;
    timestamps[head] = now;
    let i = tail;
    let bytesCount = 0;
    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }
    head = (head + 1) % samplesCount;
    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }
    if (now - firstSampleTS < min) {
      return;
    }
    const passed = startedAt && now - startedAt;
    return passed ? Math.round(bytesCount * 1e3 / passed) : void 0;
  };
}
function throttle(fn, freq) {
  let timestamp = 0;
  let threshold = 1e3 / freq;
  let lastArgs;
  let timer;
  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn.apply(null, args);
  };
  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if (passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs);
        }, threshold - passed);
      }
    }
  };
  const flush = () => lastArgs && invoke(lastArgs);
  return [throttled, flush];
}
const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);
  return throttle((e) => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : void 0;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;
    bytesNotified = loaded;
    const data = {
      loaded,
      total,
      progress: total ? loaded / total : void 0,
      bytes: progressBytes,
      rate: rate ? rate : void 0,
      estimated: rate && total && inRange ? (total - loaded) / rate : void 0,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? "download" : "upload"]: true
    };
    listener(data);
  }, freq);
};
const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;
  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
};
const asyncDecorator = (fn) => (...args) => utils$1.asap(() => fn(...args));
const isURLSameOrigin = platform.hasStandardBrowserEnv ? /* @__PURE__ */ ((origin2, isMSIE) => (url) => {
  url = new URL(url, platform.origin);
  return origin2.protocol === url.protocol && origin2.host === url.host && (isMSIE || origin2.port === url.port);
})(
  new URL(platform.origin),
  platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
) : () => true;
const cookies = platform.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + "=" + encodeURIComponent(value)];
      utils$1.isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
      utils$1.isString(path) && cookie.push("path=" + path);
      utils$1.isString(domain) && cookie.push("domain=" + domain);
      secure === true && cookie.push("secure");
      document.cookie = cookie.join("; ");
    },
    read(name) {
      const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove(name) {
      this.write(name, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}
const headersToObject = (thing) => thing instanceof AxiosHeaders$1 ? { ...thing } : thing;
function mergeConfig$1(config1, config2) {
  config2 = config2 || {};
  const config = {};
  function getMergedValue(target, source, prop, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({ caseless }, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(a, b, prop, caseless) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(a, b, prop, caseless);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(void 0, a, prop, caseless);
    }
  }
  function valueFromConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(void 0, b);
    }
  }
  function defaultToConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(void 0, b);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(void 0, a);
    }
  }
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(void 0, a);
    }
  }
  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b, prop) => mergeDeepProperties(headersToObject(a), headersToObject(b), prop, true)
  };
  utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge2 = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge2(config1[prop], config2[prop], prop);
    utils$1.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
}
const resolveConfig = (config) => {
  const newConfig = mergeConfig$1({}, config);
  let { data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth } = newConfig;
  newConfig.headers = headers = AxiosHeaders$1.from(headers);
  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
  if (auth) {
    headers.set(
      "Authorization",
      "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : ""))
    );
  }
  let contentType;
  if (utils$1.isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(void 0);
    } else if ((contentType = headers.getContentType()) !== false) {
      const [type, ...tokens] = contentType ? contentType.split(";").map((token) => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || "multipart/form-data", ...tokens].join("; "));
    }
  }
  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
    if (withXSRFToken || withXSRFToken !== false && isURLSameOrigin(newConfig.url)) {
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);
      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }
  return newConfig;
};
const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
const xhrAdapter = isXHRAdapterSupported && function(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = AxiosHeaders$1.from(_config.headers).normalize();
    let { responseType, onUploadProgress, onDownloadProgress } = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;
    function done() {
      flushUpload && flushUpload();
      flushDownload && flushDownload();
      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
      _config.signal && _config.signal.removeEventListener("abort", onCanceled);
    }
    let request = new XMLHttpRequest();
    request.open(_config.method.toUpperCase(), _config.url, true);
    request.timeout = _config.timeout;
    function onloadend() {
      if (!request) {
        return;
      }
      const responseHeaders = AxiosHeaders$1.from(
        "getAllResponseHeaders" in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };
      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request = null;
    }
    if ("onloadend" in request) {
      request.onloadend = onloadend;
    } else {
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject(new AxiosError$1("Request aborted", AxiosError$1.ECONNABORTED, config, request));
      request = null;
    };
    request.onerror = function handleError() {
      reject(new AxiosError$1("Network Error", AxiosError$1.ERR_NETWORK, config, request));
      request = null;
    };
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
      const transitional2 = _config.transitional || transitionalDefaults;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new AxiosError$1(
        timeoutErrorMessage,
        transitional2.clarifyTimeoutError ? AxiosError$1.ETIMEDOUT : AxiosError$1.ECONNABORTED,
        config,
        request
      ));
      request = null;
    };
    requestData === void 0 && requestHeaders.setContentType(null);
    if ("setRequestHeader" in request) {
      utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }
    if (!utils$1.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request.responseType = _config.responseType;
    }
    if (onDownloadProgress) {
      [downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true);
      request.addEventListener("progress", downloadThrottled);
    }
    if (onUploadProgress && request.upload) {
      [uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress);
      request.upload.addEventListener("progress", uploadThrottled);
      request.upload.addEventListener("loadend", flushUpload);
    }
    if (_config.cancelToken || _config.signal) {
      onCanceled = (cancel) => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError$1(null, config, request) : cancel);
        request.abort();
        request = null;
      };
      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
      }
    }
    const protocol = parseProtocol(_config.url);
    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError$1("Unsupported protocol " + protocol + ":", AxiosError$1.ERR_BAD_REQUEST, config));
      return;
    }
    request.send(requestData || null);
  });
};
const composeSignals = (signals, timeout) => {
  const { length } = signals = signals ? signals.filter(Boolean) : [];
  if (timeout || length) {
    let controller = new AbortController();
    let aborted;
    const onabort = function(reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof AxiosError$1 ? err : new CanceledError$1(err instanceof Error ? err.message : err));
      }
    };
    let timer = timeout && setTimeout(() => {
      timer = null;
      onabort(new AxiosError$1(`timeout ${timeout} of ms exceeded`, AxiosError$1.ETIMEDOUT));
    }, timeout);
    const unsubscribe = () => {
      if (signals) {
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal2) => {
          signal2.unsubscribe ? signal2.unsubscribe(onabort) : signal2.removeEventListener("abort", onabort);
        });
        signals = null;
      }
    };
    signals.forEach((signal2) => signal2.addEventListener("abort", onabort));
    const { signal } = controller;
    signal.unsubscribe = () => utils$1.asap(unsubscribe);
    return signal;
  }
};
const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;
  if (len < chunkSize) {
    yield chunk;
    return;
  }
  let pos = 0;
  let end;
  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
};
const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk of readStream(iterable)) {
    yield* streamChunk(chunk, chunkSize);
  }
};
const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }
  const reader = stream.getReader();
  try {
    for (; ; ) {
      const { done, value } = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
};
const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator = readBytes(stream, chunkSize);
  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };
  return new ReadableStream({
    async pull(controller) {
      try {
        const { done: done2, value } = await iterator.next();
        if (done2) {
          _onFinish();
          controller.close();
          return;
        }
        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  });
};
const isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === "function";
const encodeText = isFetchSupported && (typeof TextEncoder === "function" ? /* @__PURE__ */ ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) : async (str) => new Uint8Array(await new Response(str).arrayBuffer()));
const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false;
  }
};
const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;
  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      duplexAccessed = true;
      return "half";
    }
  }).headers.has("Content-Type");
  return duplexAccessed && !hasContentType;
});
const DEFAULT_CHUNK_SIZE = 64 * 1024;
const supportsResponseStream = isReadableStreamSupported && test(() => utils$1.isReadableStream(new Response("").body));
const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};
isFetchSupported && ((res) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((type) => {
    !resolvers[type] && (resolvers[type] = utils$1.isFunction(res[type]) ? (res2) => res2[type]() : (_, config) => {
      throw new AxiosError$1(`Response type '${type}' is not supported`, AxiosError$1.ERR_NOT_SUPPORT, config);
    });
  });
})(new Response());
const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }
  if (utils$1.isBlob(body)) {
    return body.size;
  }
  if (utils$1.isSpecCompliantForm(body)) {
    const _request = new Request(platform.origin, {
      method: "POST",
      body
    });
    return (await _request.arrayBuffer()).byteLength;
  }
  if (utils$1.isArrayBufferView(body) || utils$1.isArrayBuffer(body)) {
    return body.byteLength;
  }
  if (utils$1.isURLSearchParams(body)) {
    body = body + "";
  }
  if (utils$1.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
};
const resolveBodyLength = async (headers, body) => {
  const length = utils$1.toFiniteNumber(headers.getContentLength());
  return length == null ? getBodyLength(body) : length;
};
const fetchAdapter = isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = "same-origin",
    fetchOptions
  } = resolveConfig(config);
  responseType = responseType ? (responseType + "").toLowerCase() : "text";
  let composedSignal = composeSignals([signal, cancelToken && cancelToken.toAbortSignal()], timeout);
  let request;
  const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
    composedSignal.unsubscribe();
  });
  let requestContentLength;
  try {
    if (onUploadProgress && supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
      let _request = new Request(url, {
        method: "POST",
        body: data,
        duplex: "half"
      });
      let contentTypeHeader;
      if (utils$1.isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) {
        headers.setContentType(contentTypeHeader);
      }
      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(
          requestContentLength,
          progressEventReducer(asyncDecorator(onUploadProgress))
        );
        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
      }
    }
    if (!utils$1.isString(withCredentials)) {
      withCredentials = withCredentials ? "include" : "omit";
    }
    const isCredentialsSupported = "credentials" in Request.prototype;
    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: isCredentialsSupported ? withCredentials : void 0
    });
    let response = await fetch(request);
    const isStreamResponse = supportsResponseStream && (responseType === "stream" || responseType === "response");
    if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
      const options = {};
      ["status", "statusText", "headers"].forEach((prop) => {
        options[prop] = response[prop];
      });
      const responseContentLength = utils$1.toFiniteNumber(response.headers.get("content-length"));
      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
        responseContentLength,
        progressEventReducer(asyncDecorator(onDownloadProgress), true)
      ) || [];
      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
          flush && flush();
          unsubscribe && unsubscribe();
        }),
        options
      );
    }
    responseType = responseType || "text";
    let responseData = await resolvers[utils$1.findKey(resolvers, responseType) || "text"](response, config);
    !isStreamResponse && unsubscribe && unsubscribe();
    return await new Promise((resolve, reject) => {
      settle(resolve, reject, {
        data: responseData,
        headers: AxiosHeaders$1.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      });
    });
  } catch (err) {
    unsubscribe && unsubscribe();
    if (err && err.name === "TypeError" && /fetch/i.test(err.message)) {
      throw Object.assign(
        new AxiosError$1("Network Error", AxiosError$1.ERR_NETWORK, config, request),
        {
          cause: err.cause || err
        }
      );
    }
    throw AxiosError$1.from(err, err && err.code, config, request);
  }
});
const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};
utils$1.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, "name", { value });
    } catch (e) {
    }
    Object.defineProperty(fn, "adapterName", { value });
  }
});
const renderReason = (reason) => `- ${reason}`;
const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;
const adapters = {
  getAdapter: (adapters2) => {
    adapters2 = utils$1.isArray(adapters2) ? adapters2 : [adapters2];
    const { length } = adapters2;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters2[i];
      let id;
      adapter = nameOrAdapter;
      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
        if (adapter === void 0) {
          throw new AxiosError$1(`Unknown adapter '${id}'`);
        }
      }
      if (adapter) {
        break;
      }
      rejectedReasons[id || "#" + i] = adapter;
    }
    if (!adapter) {
      const reasons = Object.entries(rejectedReasons).map(
        ([id, state]) => `adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build")
      );
      let s = length ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
      throw new AxiosError$1(
        `There is no suitable adapter to dispatch the request ` + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return adapter;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new CanceledError$1(null, config);
  }
}
function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = AxiosHeaders$1.from(config.headers);
  config.data = transformData.call(
    config,
    config.transformRequest
  );
  if (["post", "put", "patch"].indexOf(config.method) !== -1) {
    config.headers.setContentType("application/x-www-form-urlencoded", false);
  }
  const adapter = adapters.getAdapter(config.adapter || defaults.adapter);
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );
    response.headers = AxiosHeaders$1.from(response.headers);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel$1(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders$1.from(reason.response.headers);
      }
    }
    return Promise.reject(reason);
  });
}
const VERSION$1 = "1.7.9";
const validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((type, i) => {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function transitional(validator2, version, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION$1 + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return (value, opt, opts) => {
    if (validator2 === false) {
      throw new AxiosError$1(
        formatMessage(opt, " has been removed" + (version ? " in " + version : "")),
        AxiosError$1.ERR_DEPRECATED
      );
    }
    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" + version + " and will be removed in the near future"
        )
      );
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
validators$1.spelling = function spelling(correctSpelling) {
  return (value, opt) => {
    console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
    return true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new AxiosError$1("options must be an object", AxiosError$1.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator2 = schema[opt];
    if (validator2) {
      const value = options[opt];
      const result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new AxiosError$1("option " + opt + " must be " + result, AxiosError$1.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError$1("Unknown option " + opt, AxiosError$1.ERR_BAD_OPTION);
    }
  }
}
const validator = {
  assertOptions,
  validators: validators$1
};
const validators = validator.validators;
let Axios$1 = class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy = {};
        Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
        try {
          if (!err.stack) {
            err.stack = stack;
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) {
            err.stack += "\n" + stack;
          }
        } catch (e) {
        }
      }
      throw err;
    }
  }
  _request(configOrUrl, config) {
    if (typeof configOrUrl === "string") {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }
    config = mergeConfig$1(this.defaults, config);
    const { transitional: transitional2, paramsSerializer, headers } = config;
    if (transitional2 !== void 0) {
      validator.assertOptions(transitional2, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }
    if (paramsSerializer != null) {
      if (utils$1.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }
    validator.assertOptions(config, {
      baseUrl: validators.spelling("baseURL"),
      withXsrfToken: validators.spelling("withXSRFToken")
    }, true);
    config.method = (config.method || this.defaults.method || "get").toLowerCase();
    let contextHeaders = headers && utils$1.merge(
      headers.common,
      headers[config.method]
    );
    headers && utils$1.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (method) => {
        delete headers[method];
      }
    );
    config.headers = AxiosHeaders$1.concat(contextHeaders, headers);
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
        return;
      }
      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    let promise;
    let i = 0;
    let len;
    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), void 0];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;
      promise = Promise.resolve(config);
      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }
      return promise;
    }
    len = requestInterceptorChain.length;
    let newConfig = config;
    i = 0;
    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }
    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }
    i = 0;
    len = responseInterceptorChain.length;
    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }
    return promise;
  }
  getUri(config) {
    config = mergeConfig$1(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
};
utils$1.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig$1(config || {}, {
        method,
        headers: isForm ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url,
        data
      }));
    };
  }
  Axios$1.prototype[method] = generateHTTPMethod();
  Axios$1.prototype[method + "Form"] = generateHTTPMethod(true);
});
let CancelToken$1 = class CancelToken {
  constructor(executor) {
    if (typeof executor !== "function") {
      throw new TypeError("executor must be a function.");
    }
    let resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    const token = this;
    this.promise.then((cancel) => {
      if (!token._listeners) return;
      let i = token._listeners.length;
      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });
    this.promise.then = (onfulfilled) => {
      let _resolve;
      const promise = new Promise((resolve) => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);
      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel(message, config, request) {
      if (token.reason) {
        return;
      }
      token.reason = new CanceledError$1(message, config, request);
      resolvePromise(token.reason);
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }
  toAbortSignal() {
    const controller = new AbortController();
    const abort = (err) => {
      controller.abort(err);
    };
    this.subscribe(abort);
    controller.signal.unsubscribe = () => this.unsubscribe(abort);
    return controller.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
};
function spread$1(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}
function isAxiosError$1(payload) {
  return utils$1.isObject(payload) && payload.isAxiosError === true;
}
const HttpStatusCode$1 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode$1).forEach(([key, value]) => {
  HttpStatusCode$1[value] = key;
});
function createInstance(defaultConfig) {
  const context = new Axios$1(defaultConfig);
  const instance = bind(Axios$1.prototype.request, context);
  utils$1.extend(instance, Axios$1.prototype, context, { allOwnKeys: true });
  utils$1.extend(instance, context, null, { allOwnKeys: true });
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig$1(defaultConfig, instanceConfig));
  };
  return instance;
}
const axios = createInstance(defaults);
axios.Axios = Axios$1;
axios.CanceledError = CanceledError$1;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel$1;
axios.VERSION = VERSION$1;
axios.toFormData = toFormData$1;
axios.AxiosError = AxiosError$1;
axios.Cancel = axios.CanceledError;
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = spread$1;
axios.isAxiosError = isAxiosError$1;
axios.mergeConfig = mergeConfig$1;
axios.AxiosHeaders = AxiosHeaders$1;
axios.formToJSON = (thing) => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = HttpStatusCode$1;
axios.default = axios;
const {
  Axios: Axios2,
  AxiosError,
  CanceledError,
  isCancel,
  CancelToken: CancelToken2,
  VERSION,
  all: all2,
  Cancel,
  isAxiosError,
  spread,
  toFormData,
  AxiosHeaders: AxiosHeaders2,
  HttpStatusCode,
  formToJSON,
  getAdapter,
  mergeConfig
} = axios;
const IconPhone = ({ size = 16 }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 16 16", fill: "none", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_196_356)", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "16", height: "16", fill: "white" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M10.0333 3.33329C10.6845 3.46034 11.2829 3.7788 11.752 4.24792C12.2211 4.71703 12.5396 5.31547 12.6666 5.96663M10.0333 0.666626C11.3862 0.816917 12.6477 1.42274 13.6108 2.38463C14.5739 3.34652 15.1813 4.6073 15.3333 5.95996M14.6666 11.28V13.28C14.6674 13.4656 14.6294 13.6494 14.555 13.8195C14.4806 13.9896 14.3715 14.1424 14.2347 14.2679C14.0979 14.3934 13.9364 14.4889 13.7605 14.5484C13.5846 14.6079 13.3982 14.63 13.2133 14.6133C11.1619 14.3904 9.19131 13.6894 7.45998 12.5666C5.84919 11.5431 4.48353 10.1774 3.45998 8.56663C2.33329 6.82743 1.63214 4.84729 1.41331 2.78663C1.39665 2.60227 1.41856 2.41647 1.47764 2.24104C1.53673 2.06562 1.63169 1.90442 1.75649 1.76771C1.88128 1.63099 2.03318 1.52177 2.2025 1.44697C2.37183 1.37218 2.55487 1.33347 2.73998 1.33329H4.73998C5.06351 1.33011 5.37717 1.44468 5.62248 1.65565C5.8678 1.86662 6.02803 2.15959 6.07331 2.47996C6.15772 3.12 6.31428 3.74844 6.53998 4.35329C6.62967 4.59191 6.64908 4.85124 6.59591 5.10055C6.54274 5.34986 6.41922 5.5787 6.23998 5.75996L5.39331 6.60663C6.34235 8.27566 7.72428 9.65759 9.39331 10.6066L10.24 9.75996C10.4212 9.58072 10.6501 9.45719 10.8994 9.40402C11.1487 9.35085 11.408 9.37026 11.6466 9.45996C12.2515 9.68566 12.8799 9.84221 13.52 9.92663C13.8438 9.97231 14.1396 10.1354 14.351 10.385C14.5624 10.6345 14.6748 10.953 14.6666 11.28Z", stroke: "#66666C", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_196_356", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
  ] }) });
};
const IconMap = ({ size = 16 }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 16 16", fill: "none", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_196_357)", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "16", height: "16", fill: "white" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M14 6.66663C14 11.3333 8 15.3333 8 15.3333C8 15.3333 2 11.3333 2 6.66663C2 5.07533 2.63214 3.5492 3.75736 2.42399C4.88258 1.29877 6.4087 0.666626 8 0.666626C9.5913 0.666626 11.1174 1.29877 12.2426 2.42399C13.3679 3.5492 14 5.07533 14 6.66663Z", stroke: "#66666C", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M8 8.66663C9.10457 8.66663 10 7.7712 10 6.66663C10 5.56206 9.10457 4.66663 8 4.66663C6.89543 4.66663 6 5.56206 6 6.66663C6 7.7712 6.89543 8.66663 8 8.66663Z", stroke: "#66666C", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_196_357", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
  ] }) });
};
const IconClock = ({ size = 16 }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", height: size, width: size, fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "12", cy: "12", r: "10" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("polyline", { points: "12 6 12 12 16 14" })
  ] });
};
const PromoModal = ({ onClose }) => {
  const {
    title,
    subtitle,
    description,
    image,
    imageAltText
  } = window.schedulerVariantStrings.promoModal;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center px-4", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-shadow-black text-fairway w-full max-w-3xl rounded-md relative", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        onClick: onClose,
        className: "absolute top-3 right-3 text-fairway text-2xl",
        "aria-label": "Close modal",
        children: "×"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "text-center pt-8", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "text-2xl font-semibold font-display", children: title }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sunrise italic mt-2 text-lg font-display", children: subtitle })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        src: image,
        alt: imageAltText,
        className: "w-full object-contain"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-fairway text-shadow-black px-10 py-10 rounded-b-md", children: description })
  ] }) });
};
const WorkTypes = ({ translations, filteredWorkTypes, onWorkTypeSelect, selectedWorkTypeId, selectedStoreName, loggedIn, selectedStoreObj }) => {
  const [isModalOpen, setIsModalOpen] = reactExports.useState(false);
  const showModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "scroll-mt-[var(--nav-height)]", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "content-md mx-auto text-center pb-9", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "text-center font-display text-2xl font-semibold capitalize not-italic leading-normal text-black pb-4", children: translations == null ? void 0 : translations.workTypesTitle.replace("{storeName}", selectedStoreName) }),
      (selectedStoreObj.address || selectedStoreObj.phone) && /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "div",
        {
          className: `flex pb-4 w-full gap-4 ${selectedStoreObj.address && selectedStoreObj.phone ? "justify-between" : "justify-center"}`,
          children: [
            selectedStoreObj.address && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `${selectedStoreObj.phone ? "flex-1" : "w-full justify-center"} flex items-baseline gap-1`, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-4 h-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconMap, { size: "16" }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "a",
                {
                  className: "underline underline-offset-2 decoration-1 hover:decoration-2 text-xs text-left",
                  href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                    selectedStoreObj.address
                  )}`,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: selectedStoreObj.address
                }
              )
            ] }),
            selectedStoreObj.phone && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `${selectedStoreObj.address ? "flex-1" : "w-full justify-center"} flex items-baseline gap-1`, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-4 h-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPhone, { size: "16" }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(
                "a",
                {
                  className: "underline underline-offset-2 decoration-1 hover:decoration-2 text-xs text-left",
                  href: selectedStoreObj.hrefFormattedPhoneNumber,
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "sr-only", children: `Call ${selectedStoreObj.name}` }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: selectedStoreObj.phone })
                  ]
                }
              )
            ] })
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-left text-sm pb-4", children: translations == null ? void 0 : translations.workTypesHeaderContent }),
      (translations == null ? void 0 : translations.promoText) && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center w-full pt-4", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex-grow border-t border-shadow-black" }),
        window.schedulerVariantStrings.promoModal.openPromoModal ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            className: "px-3 py-2 border border-shadow-black rounded-sm text-xs font-bold text-swing-red",
            onClick: showModal,
            children: translations.promoText
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
          "span",
          {
            className: "px-3 py-2 border border-shadow-black rounded-sm text-xs font-bold text-swing-red",
            "aria-disabled": "true",
            children: translations.promoText
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex-grow border-t border-shadow-black" })
      ] })
    ] }),
    isModalOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(PromoModal, { onClose: closeModal }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-12 md:col-10 md:offset-1", children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6", children: filteredWorkTypes.map((workType) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "col flex", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "button",
      {
        className: `flex flex-col w-full border ${selectedWorkTypeId === workType.id ? "bg-shadow-black" : ""} border-shadow-black rounded-lg p-4 pt-6 relative`,
        onClick: () => onWorkTypeSelect(workType),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: `mb-2 font-display text-left text-lg ${selectedWorkTypeId === workType.id ? "text-fairway" : ""} font-semibold capitalize not-italic`, children: workType.name }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `text whitespace-nowrap ${selectedWorkTypeId === workType.id ? "bg-swing-red" : "bg-shadow-black"} text-fairway px-2 py-1 text-center align-baseline font-semibold absolute top-0 right-0 rounded-tr-lg rounded-bl-lg -mt-px -mr-px`, children: [
            workType.duration,
            " ",
            workType.durationUnits
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: `mb-4 flex-auto text-left text-sm ${selectedWorkTypeId === workType.id ? "text-fairway" : ""}`, children: workType.description })
        ]
      }
    ) }, workType.id)) }) })
  ] });
};
const IconChevronDown = ({ inlineOrBlock = "inline", rotate = false }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      className: `${inlineOrBlock}`,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      style: {
        transition: "transform 0.3s ease",
        transform: rotate ? "rotate(-180deg)" : "rotate(0deg)"
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M18 9.99984L16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984Z",
          fill: "#201E25"
        }
      )
    }
  );
};
const CustomerInformationForm = ({ onSubmit, translations, storeAcuityLocale, loggedInCustomerData }) => {
  const [firstName, setFirstName] = reactExports.useState("");
  const [lastName, setLastName] = reactExports.useState("");
  const [phone, setPhone] = reactExports.useState("");
  const [email, setEmail] = reactExports.useState("");
  const [howDidYouHearAboutUs, setHowDidYouHearAboutUs] = reactExports.useState("");
  const [smsOptIn, setSmsOptIn] = reactExports.useState(false);
  const [certificate, setCertificate] = reactExports.useState("");
  const [addressLine1, setAddressLine1] = reactExports.useState("");
  const [addressLine2, setAddressLine2] = reactExports.useState("");
  const [city, setCity] = reactExports.useState("");
  const [postalCode, setPostalCode] = reactExports.useState("");
  const [homeCourse, setHomeCourse] = reactExports.useState("");
  const [customerHeroStatus, setCustomerHeroStatus] = reactExports.useState(false);
  const [customerStudent, setCustomerStudent] = reactExports.useState(false);
  const [state, setState] = reactExports.useState("");
  const [dexterity, setDexterity] = reactExports.useState("");
  const [stayInformed, setStayInformed] = reactExports.useState(false);
  const [referralCodeChevronRotated, setReferralCodeChevronRotated] = reactExports.useState(false);
  reactExports.useEffect(() => {
    if (loggedInCustomerData) {
      setFirstName(loggedInCustomerData.customerFirstName);
      setLastName(loggedInCustomerData.customerLastName);
      setEmail(loggedInCustomerData.customerEmail);
      setPhone(loggedInCustomerData.customerPhone);
      setStayInformed(Boolean(loggedInCustomerData.customerAcceptsMarketing));
    } else if (Shopify.country === "US") {
      setStayInformed(true);
    }
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const acuityCustomerInfo = {
      firstName,
      lastName,
      phone,
      email,
      certificate,
      stayInformed,
      ...storeAcuityLocale === "en_US" && {
        howDidYouHearAboutUs,
        smsOptIn
      },
      ...storeAcuityLocale === "en_GB" && {
        addressLine1,
        addressLine2,
        city,
        postalCode,
        homeCourse,
        isHero: customerHeroStatus,
        isStudent: customerStudent
      },
      ...storeAcuityLocale === "ja_JP" && {
        postalCode,
        state,
        city,
        addressLine1,
        dexterity
      }
    };
    try {
      await fetch("/apps/pxg/v1/customer-upsert", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          input: {
            firstName,
            lastName,
            email,
            phone,
            emailMarketingConsent: {
              marketingState: stayInformed ? "SUBSCRIBED" : "UNSUBSCRIBED",
              marketingOptInLevel: "SINGLE_OPT_IN",
              consentUpdatedAt: (/* @__PURE__ */ new Date()).toISOString()
            }
          }
        })
      });
    } catch (err) {
      console.error("Error submitting customer info:", err);
    }
    onSubmit(acuityCustomerInfo);
  };
  const toggleReferralCodeFieldVisibility = (e) => {
    e.preventDefault();
    const referralCodeInputField = document.querySelector("#customerInfoFormPromoCode");
    if (referralCodeInputField.classList.contains("hidden")) {
      referralCodeInputField.classList.remove("hidden");
      referralCodeInputField.classList.add("block");
    } else {
      referralCodeInputField.classList.remove("block");
      referralCodeInputField.classList.add("hidden");
    }
    setReferralCodeChevronRotated(!referralCodeChevronRotated);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("form", { onSubmit: handleSubmit, className: "*:mb-5", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "field-block field-stack", htmlFor: "customerInfoFormFirstName", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "text",
          id: "customerInfoFormFirstName",
          className: "field-input rounded-md border-shadow-black shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25",
          value: firstName,
          placeholder: "",
          onChange: (e) => setFirstName(e.target.value),
          required: true
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "field-label", children: [
        translations == null ? void 0 : translations.piiFirstName,
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: "*" })
      ] })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "field-block field-stack", htmlFor: "customerInfoFormLastName", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "text",
          id: "customerInfoFormLastName",
          className: "field-input rounded-md border-shadow-black shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25",
          value: lastName,
          placeholder: "",
          onChange: (e) => setLastName(e.target.value),
          required: true
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "field-label", children: [
        translations == null ? void 0 : translations.piiLastName,
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: "*" })
      ] })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "field-block field-stack", htmlFor: "customerInfoFormTel", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "tel",
          id: "customerInfoFormTel",
          className: "field-input rounded-md border-shadow-black shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25",
          value: phone,
          placeholder: "",
          onChange: (e) => setPhone(e.target.value),
          required: true
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "field-label", children: [
        translations == null ? void 0 : translations.piiPhone,
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: "*" })
      ] })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "field-block field-stack", htmlFor: "customerInfoFormEmail", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "email",
          id: "customerInfoFormEmail",
          className: "field-input rounded-md border-shadow-black shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25",
          value: email,
          placeholder: "",
          onChange: (e) => setEmail(e.target.value),
          required: true
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "field-label", children: [
        translations == null ? void 0 : translations.piiEmail,
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: "*" })
      ] })
    ] }) }),
    storeAcuityLocale === "en_GB" && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "field-block field-stack", htmlFor: "customerInfoFormAddressLine1", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "text",
            id: "customerInfoFormAddressLine1",
            className: "field-input rounded-md border-shadow-black shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25",
            value: addressLine1,
            placeholder: "",
            onChange: (e) => setAddressLine1(e.target.value),
            required: true
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "field-label", children: [
          translations == null ? void 0 : translations.piiAddress1,
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: "*" })
        ] })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "field-block field-stack", htmlFor: "customerInfoFormAddressLine2", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "text",
            id: "customerInfoFormAddressLine2",
            className: "field-input rounded-md border-shadow-black shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25",
            value: addressLine2,
            placeholder: "",
            onChange: (e) => setAddressLine2(e.target.value)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "field-label", children: translations == null ? void 0 : translations.piiAddress2 })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "field-block field-stack", htmlFor: "customerInfoFormAddressCity", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "text",
            id: "customerInfoFormAddressCity",
            className: "field-input rounded-md border-shadow-black shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25",
            value: city,
            placeholder: "",
            onChange: (e) => setCity(e.target.value),
            required: true
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "field-label", children: [
          translations == null ? void 0 : translations.piiCity,
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: "*" })
        ] })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "field-block field-stack", htmlFor: "customerInfoFormAddressPostalCode", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "text",
            id: "customerInfoFormAddressPostalCode",
            className: "field-input rounded-md border-shadow-black shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25",
            value: postalCode,
            placeholder: "",
            onChange: (e) => setPostalCode(e.target.value),
            required: true
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "field-label", children: [
          translations == null ? void 0 : translations.piiPostalCode,
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: "*" })
        ] })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "field-block field-stack", htmlFor: "customerInfoHomeCourse", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "text",
            id: "customerInfoHomeCourse",
            className: "field-input rounded-md border-shadow-black shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25",
            value: homeCourse,
            placeholder: "",
            onChange: (e) => setHomeCourse(e.target.value),
            required: true
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "field-label", children: [
          translations == null ? void 0 : translations.piiHomeCourse,
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: "*" })
        ] })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "checkbox",
            id: "customerInfoHero",
            className: "!w-4 mr-2 rounded border-shadow-black-light text-shadow-black-light shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25 focus:ring-offset-0",
            checked: customerHeroStatus,
            onChange: (e) => setCustomerHeroStatus(e.target.checked)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "customerInfoHero", children: translations == null ? void 0 : translations.piiHeroes })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "checkbox",
            id: "customerInfoStudent",
            className: "!w-4 mr-2 rounded border-shadow-black-light text-shadow-black-light shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25 focus:ring-offset-0",
            checked: customerStudent,
            onChange: (e) => setCustomerStudent(e.target.checked)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "customerInfoStudent", children: translations == null ? void 0 : translations.piiStudent })
      ] })
    ] }),
    storeAcuityLocale === "ja_JP" && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "field-block field-stack", htmlFor: "customerInfoFormAddressPostalCode", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "text",
            id: "customerInfoFormAddressPostalCode",
            className: "field-input rounded-md border-shadow-black shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25",
            value: postalCode,
            placeholder: "",
            onChange: (e) => setPostalCode(e.target.value),
            required: true
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "field-label", children: [
          translations == null ? void 0 : translations.piiPostalCode,
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: "*" })
        ] })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "field-block field-stack", htmlFor: "customerInfoFormAddressPrefecture", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "text",
            id: "customerInfoFormAddressPrefecture",
            className: "field-input rounded-md border-shadow-black shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25",
            value: state,
            placeholder: "",
            onChange: (e) => setState(e.target.value),
            required: true
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "field-label", children: [
          translations == null ? void 0 : translations.piiPrefecture,
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: "*" })
        ] })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "field-block field-stack", htmlFor: "customerInfoFormAddressCity", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "text",
            id: "customerInfoFormAddressCity",
            className: "field-input rounded-md border-shadow-black shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25",
            value: city,
            placeholder: "",
            onChange: (e) => setCity(e.target.value),
            required: true
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "field-label", children: [
          translations == null ? void 0 : translations.piiCity,
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: "*" })
        ] })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "field-block field-stack", htmlFor: "customerInfoFormAddressWardTownVillageStreet", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "text",
            id: "customerInfoFormAddressWardTownVillageStreet",
            className: "field-input rounded-md border-shadow-black shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25",
            value: addressLine1,
            placeholder: "",
            onChange: (e) => setAddressLine1(e.target.value),
            required: true
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "field-label", children: [
          translations == null ? void 0 : translations.piiJpAddress,
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: "*" })
        ] })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "label",
        {
          className: `field-block field-stack ${dexterity ? "has-value" : ""}`,
          htmlFor: "customerInfoFormDexterity",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              "select",
              {
                id: "customerInfoFormDexterity",
                className: "field-select rounded-md border-shadow-black shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25",
                value: dexterity,
                onChange: (e) => setDexterity(e.target.value),
                required: true,
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "右打ち", children: translations == null ? void 0 : translations.piiDexterityOptionRight }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "左打ち", children: translations == null ? void 0 : translations.piiDexterityOptionLeft })
                ]
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "field-label", children: [
              translations == null ? void 0 : translations.piiDexterity,
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: "*" })
            ] })
          ]
        }
      ) })
    ] }),
    storeAcuityLocale === "en_US" && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "label",
        {
          className: `field-block field-stack ${howDidYouHearAboutUs ? "has-value" : ""}`,
          htmlFor: "customerInformationHowDidYouHearAboutUs",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              "select",
              {
                id: "customerInformationHowDidYouHearAboutUs",
                className: "field-select rounded-md border-shadow-black shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25",
                value: howDidYouHearAboutUs,
                onChange: (e) => setHowDidYouHearAboutUs(e.target.value),
                required: true,
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "Social Media", children: window.schedulerVariantStrings.socialMedia }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "YouTube", children: window.schedulerVariantStrings.youtube }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "TV", children: window.schedulerVariantStrings.tv }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "Search Engine", children: window.schedulerVariantStrings.searchEngine }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "Referral by Family/Friend", children: window.schedulerVariantStrings.referral }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "Golf Course Referral", children: window.schedulerVariantStrings.golfCourse }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "Podcast / Radio", children: window.schedulerVariantStrings.podcast }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "Billboard Signage", children: window.schedulerVariantStrings.billboardSignage }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "Magazine", children: window.schedulerVariantStrings.magazine }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "Golf Show", children: window.schedulerVariantStrings.golfShow }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "In-Store Event", children: window.schedulerVariantStrings.inStore }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "Out of Store Event", children: window.schedulerVariantStrings.outofStore }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "Upper Deck Golf", children: window.schedulerVariantStrings.upperDeck }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "Physical Mall", children: window.schedulerVariantStrings.physicalMail }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "Email", children: window.schedulerVariantStrings.email }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "Golf Association", children: window.schedulerVariantStrings.golfAssociation }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "PGA of America", children: window.schedulerVariantStrings.pgaofAmerica }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "Military Group", children: window.schedulerVariantStrings.militaryGroup })
                ]
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "field-label", children: [
              window.schedulerVariantStrings.howDidYouHearAboutUsLabel,
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: "*" })
            ] })
          ]
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-top", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            id: "smsOptIn",
            type: "checkbox",
            className: "!w-4 mr-2 rounded border-shadow-black-light text-shadow-black-light shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25 focus:ring-offset-0 mt-1",
            checked: smsOptIn,
            onChange: (e) => setSmsOptIn(e.target.checked)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col gap-1", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "label",
            {
              className: "mr-2 font-bold",
              htmlFor: "smsOptIn",
              children: translations == null ? void 0 : translations.acuitySmsOptInLabel
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: translations == null ? void 0 : translations.piiSmsOptInDetails })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "checkbox",
          id: "customerInfoStayInformed",
          className: "!w-4 mr-2 rounded border-shadow-black-light text-shadow-black-light shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25 focus:ring-offset-0",
          checked: stayInformed,
          onChange: (e) => setStayInformed(e.target.checked)
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { htmlFor: "customerInfoStayInformed", children: [
        translations == null ? void 0 : translations.piiMarketingOptIn,
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("a", { target: "_blank", className: "underline", href: "/policies/privacy-policy", children: translations == null ? void 0 : translations.piiPrivacyPolicy })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("button", { onClick: toggleReferralCodeFieldVisibility, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "customerInfoFormPromoCode", children: translations == null ? void 0 : translations.piiReferralCode }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconChevronDown,
          {
            inlineOrBlock: "inline",
            rotate: referralCodeChevronRotated
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "text",
          id: "customerInfoFormPromoCode",
          className: "mt-1 hidden w-full rounded-md border-shadow-black shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25",
          value: certificate,
          onChange: (e) => setCertificate(e.target.value)
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "btn-primary btn-lg", type: "submit", children: translations == null ? void 0 : translations.appointmentBookingButtonText })
  ] });
};
const LoadingIndicator = ({ displayedText }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-5 mx-auto flex flex-col h-44 w-full items-center justify-center", role: "status", children: [
    displayedText && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-2 mb-4 text-center text-md text-shadow-black", children: displayedText }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "svg",
      {
        "aria-hidden": "true",
        className: "inline h-8 w-8 animate-spin fill-gray-600 text-gray-200 dark:fill-gray-300 dark:text-gray-600",
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
              fill: "currentFill"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "sr-only", children: "Loading..." })
  ] });
};
const BookingSuccess = ({ bookAnotherAppointmentHandler }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "w-full", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        src: window.schedulerVariantStrings.bookingSuccessFailure.image,
        alt: window.schedulerVariantStrings.bookingSuccessFailure.imageAltText
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "my-5 text-sm leading-8",
        dangerouslySetInnerHTML: {
          __html: window.schedulerVariantStrings.bookingSuccessFailure.body
        }
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex gap-6 justify-center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          href: window.schedulerVariantStrings.bookingSuccessFailure.redirectButtonLink,
          className: "btn btn-primary flex-1 py-2 text-sm",
          children: window.schedulerVariantStrings.bookingSuccessFailure.redirectButtonText
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          onClick: () => bookAnotherAppointmentHandler(true),
          className: "btn btn-secondary flex-1 py-2 text-sm",
          children: window.schedulerVariantStrings.bookingSuccessFailure.bookAnotherFittingButtonText
        }
      )
    ] })
  ] });
};
const FinalBooking = ({
  selectedStoreObj,
  finalBookingObject,
  finalBookingRef,
  bookAnotherAppointmentHandler,
  acuityLink,
  translations,
  storeAcuityLocale,
  loggedIn,
  dataLayerErrorHandler,
  addOn,
  selectedWorkTypeAvailableAddOns,
  selectedCalendarIds,
  loggedInCustomerData
}) => {
  const [bookingStatus, setBookingStatus] = reactExports.useState(null);
  const [loading, setLoading] = reactExports.useState(false);
  const [addonIds, setAddonIds] = reactExports.useState(/* @__PURE__ */ new Set());
  const handleBookingSubmission = async (data) => {
    var _a;
    setLoading(true);
    const { workType, workTypeName, dateTimeReadable, ...filteredData } = data;
    filteredData.locale = storeAcuityLocale;
    filteredData.calendarIds = selectedCalendarIds;
    try {
      const response = await axios.post(
        `https://${Shopify.pxgApiEndpoint}/acuity/schedule-appointment`,
        filteredData
      );
      window.ElevarDataLayer = window.ElevarDataLayer || [];
      if (response.data.status_code === 0) {
        setBookingStatus("success");
        window.ElevarDataLayer.push({
          event: "dl_customer_information",
          locationName: selectedStoreObj.name,
          loggedIn,
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          phoneNumber: data.phone
        });
        window.ElevarDataLayer.push({
          event: "dl_appointment_booking",
          locationName: selectedStoreObj.name,
          loggedIn,
          fittingExperience: data.workTypeName,
          appointmentDate: data.dateTimeReadable,
          currencyCode: Shopify.currency.active,
          ecommerce: {
            purchase: {
              actionField: {
                id: response.data.appointment.id,
                affiliation: "PXG",
                revenue: "0",
                tax: "0",
                shipping: "0",
                coupon: null,
                newCustomer: loggedIn,
                shippingMethod: "NA",
                paymentMethod: "NA"
              },
              products: [
                {
                  name: data.workTypeName,
                  id: data.appointmentTypeId,
                  price: "0.00",
                  variant: null,
                  brand: "PXG",
                  quantity: 1,
                  category: "Fitting",
                  coupon: null,
                  dimension3: "Web",
                  dimension4: storeAcuityLocale,
                  appointmentDate: data.dateTimeReadable
                }
              ]
            }
          }
        });
      } else {
        setBookingStatus("failure");
        const errorType = "Server Error";
        const errorMessage = JSON.stringify({
          status_code: response.data.status_code,
          message: response.data.message || "Booking failed - no message in response",
          response: response.data
        });
        dataLayerErrorHandler("dl_fitting_error", "appointmentBooking", errorType, errorMessage);
        console.error("Booking failed response:", response.data);
      }
    } catch (error) {
      console.error("Error:", error);
      setBookingStatus("failure");
      let errorType = "FrontEnd JS";
      if (axios.isAxiosError(error)) {
        if (error.response) {
          errorType = "Server Error";
        } else if (error.request) {
          errorType = "Axios/Network";
        }
      }
      const serializedError = ((_a = error.toJSON) == null ? void 0 : _a.call(error)) || {
        name: error.name,
        message: error.message,
        stack: error.stack
      };
      dataLayerErrorHandler("dl_fitting_error", "appointmentBooking", errorType, JSON.stringify(serializedError));
      console.error("Error during booking submission:", serializedError);
      window.location.href = acuityLink;
    } finally {
      setLoading(false);
    }
  };
  const handleCustomerSubmit = (customerForm) => {
    const combinedData = { ...finalBookingObject, ...customerForm };
    if (addonIds.size > 0) {
      combinedData.addonIds = Array.from(addonIds);
    }
    handleBookingSubmission(combinedData);
  };
  const addOnIdHandler = (checkedStatus, addOnId) => {
    setAddonIds((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(addOnId) && !checkedStatus) {
        newSet.delete(addOnId);
      } else if (!newSet.has(addOnId) && checkedStatus === true) {
        newSet.add(addOnId);
      }
      return newSet;
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "scroll-mt-[var(--nav-height)] relative", ref: finalBookingRef, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "h1 text-center font-display text-xl font-semibold capitalize not-italic leading-normal text-black py-4", children: translations == null ? void 0 : translations.finalBookingTitle }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col items-center justify-center content-md mx-auto", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: `flex gap-4 w-full pb-4 ${selectedStoreObj.address && selectedStoreObj.phone ? "justify-between" : "justify-center"}`,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(
                "div",
                {
                  className: `flex items-baseline gap-1 ${selectedStoreObj.address && selectedStoreObj.phone ? "w-1/3" : selectedStoreObj.address || selectedStoreObj.phone ? "w-1/2" : "w-full justify-center"}`,
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-4 h-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconClock, { size: "16" }) }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-xs", children: finalBookingObject.dateTimeReadable })
                  ]
                }
              ),
              selectedStoreObj.address && /* @__PURE__ */ jsxRuntimeExports.jsxs(
                "div",
                {
                  className: `flex items-baseline gap-1 ${selectedStoreObj.phone ? "w-1/3" : "w-1/2 justify-center"}`,
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-4 h-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconMap, { size: "16" }) }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "a",
                      {
                        className: "underline underline-offset-2 decoration-1 hover:decoration-2 text-xs text-left",
                        href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                          selectedStoreObj.address
                        )}`,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: selectedStoreObj.address
                      }
                    )
                  ]
                }
              ),
              selectedStoreObj.phone && /* @__PURE__ */ jsxRuntimeExports.jsxs(
                "div",
                {
                  className: `flex items-baseline gap-1 ${selectedStoreObj.address ? "w-1/3" : "w-1/2 justify-center"}`,
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-4 h-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPhone, { size: "16" }) }),
                    /* @__PURE__ */ jsxRuntimeExports.jsxs(
                      "a",
                      {
                        className: "underline underline-offset-2 decoration-1 hover:decoration-2 text-xs text-left",
                        href: selectedStoreObj.hrefFormattedPhoneNumber,
                        children: [
                          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "sr-only", children: `Call ${selectedStoreObj.name}` }),
                          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: selectedStoreObj.phone })
                        ]
                      }
                    )
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "border-b border-fairway-dark-2 pb-8 mb-4", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { className: "text-sm font-semibold font-body pb-2", children: finalBookingObject.workType.name }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-sm", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "sr-only", children: "Work Type Description: " }),
            finalBookingObject.workType.description
          ] }),
          addOn && selectedWorkTypeAvailableAddOns.includes(addOn.id) && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-8", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mb-4", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "inline-flex items-center mb-2", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  type: "checkbox",
                  className: "!w-4 mr-2 rounded border-shadow-black-light text-shadow-black-light shadow-sm focus:border-shadow-black-light focus:ring focus:ring-shadow-black-light focus:ring-opacity-25 focus:ring-offset-0",
                  onChange: (e) => addOnIdHandler(e.target.checked, addOn.id)
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("h4", { className: "h5 text-lg", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: translations == null ? void 0 : translations.piiAddOnChallengeLabel }),
                " ",
                addOn.name
              ] })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                className: "text-md last:mb-0 add-on-description",
                dangerouslySetInnerHTML: { __html: translations == null ? void 0 : translations.piiAddOnChallengeDescription }
              }
            )
          ] }) })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "relative w-full", children: bookingStatus === "success" && !loading ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        BookingSuccess,
        {
          bookAnotherAppointmentHandler
        }
      ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CustomerInformationForm,
          {
            onSubmit: handleCustomerSubmit,
            translations,
            storeAcuityLocale,
            storeName: selectedStoreObj.name,
            bookAnotherAppointmentHandler,
            loggedInCustomerData
          }
        ),
        bookingStatus === "failure" && !loading && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-4 text-system-negative font-semibold", children: window.schedulerVariantStrings.bookingSuccessFailure.bookingFailureErrorMessage })
      ] }) }),
      loading && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute left-0 top-0 z-10 flex h-full w-full items-center justify-center bg-white/70", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingIndicator, {}) })
    ] })
  ] });
};
const IconChevronLeft = ({ size = 6 }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: `size-6 w-${size} h-${size}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M15.75 19.5 8.25 12l7.5-7.5" }) }) });
};
const IconChevronRight = ({ size = 6 }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: `size-6 w-${size} h-${size}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "m8.25 4.5 7.5 7.5-7.5 7.5" }) }) });
};
const ShadowOverlay = ({ showLeft, showRight }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    showLeft && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "pointer-events-none absolute left-0 top-0 h-full w-8 z-10",
        style: { background: "linear-gradient(to right, #FFFDF2, transparent)" }
      }
    ),
    showRight && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "pointer-events-none absolute right-0 top-0 h-full w-8 z-10",
        style: { background: "linear-gradient(to left, #FFFDF2, transparent)" }
      }
    )
  ] });
};
const Calendar = ({
  calendarRef,
  translations,
  workTypeId,
  calendarIds,
  onAppointmentSelect,
  refreshCalendar,
  setRefreshCalendar,
  selectedTime,
  getDateFromString,
  acuityLink,
  fullLocaleString,
  storeAcuityLocale,
  hour12Format,
  capitalizeFirstLetters,
  selectedStoreName,
  loggedIn,
  workTypeName,
  dataLayerErrorHandler,
  fetchedStartDates,
  setFetchedStartDates,
  firstDateToQuery,
  setFirstDateToQuery
}) => {
  const [calendarData, setCalendarData] = reactExports.useState([]);
  const [loading, setLoading] = reactExports.useState(false);
  const [transitioning, setTransitioning] = reactExports.useState(false);
  const [lastDayReturned, setLastDayReturned] = reactExports.useState(null);
  const [previousPaginationDisabled, setPreviousPaginationDisabled] = reactExports.useState(true);
  const [dateRangeStart, setDateRangeStart] = reactExports.useState(null);
  const [dateRangeEnd, setDateRangeEnd] = reactExports.useState(null);
  const [appointmentsAvailable, setAppointmentsAvailable] = reactExports.useState(null);
  const [userPaginated, setUserPaginated] = reactExports.useState(false);
  const scrollContainers = reactExports.useRef([]);
  const [showLeftShadow, setShowLeftShadow] = reactExports.useState([]);
  const [showRightShadow, setShowRightShadow] = reactExports.useState([]);
  const getFormattedDate = (date) => {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };
  const parseAndFormatDate = (dateString, lastDate) => {
    const [year, month, day] = dateString.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    if (lastDate) {
      setLastDayReturned(date);
    }
    let shortMonth = date.toLocaleDateString(fullLocaleString, { month: "short" });
    let longMonth = date.toLocaleDateString(fullLocaleString, { month: "long" });
    if (fullLocaleString === "fr-CA") {
      shortMonth = capitalizeFirstLetters(shortMonth);
      longMonth = capitalizeFirstLetters(longMonth);
    }
    const formattedDate = {
      short: `${shortMonth} ${date.getDate()}`,
      long: `${longMonth} ${date.getDate()}`
    };
    return formattedDate;
  };
  const cleanupTimeSlots = (data) => {
    return data.map((entry) => {
      const seenTimes = /* @__PURE__ */ new Set();
      const uniqueSlots = entry.slots.filter((slot) => {
        if (seenTimes.has(slot.time)) {
          return false;
        }
        seenTimes.add(slot.time);
        return true;
      }).sort((a, b) => new Date(a.time) - new Date(b.time));
      return { ...entry, slots: uniqueSlots };
    });
  };
  const sortAndFilterDatesAndTimes = (formattedCalendarData) => {
    const cleanedData = cleanupTimeSlots(formattedCalendarData);
    const sortedCalendarData = cleanedData.sort((a, b) => new Date(a.date) - new Date(b.date));
    const limitedDataArray = sortedCalendarData.slice(0, 5);
    setCalendarData(limitedDataArray);
    return limitedDataArray.map((item) => item.date);
  };
  const fetchCalendarData = async (triggeredByPagination, paginationDateToQuery = null, addToFetchedDatesArray) => {
    var _a;
    if (triggeredByPagination) {
      setTransitioning(true);
    } else {
      setLoading(true);
    }
    const dateToQuery = paginationDateToQuery || firstDateToQuery;
    let response;
    try {
      response = await axios.post(`https://${Shopify.pxgApiEndpoint}/acuity/v2/availability`, {
        calendarIDs: calendarIds,
        date: getFormattedDate(dateToQuery),
        appointmentTypeId: workTypeId,
        locale: storeAcuityLocale
      });
      if (addToFetchedDatesArray !== false) {
        setFetchedStartDates((prev) => [...prev, dateToQuery]);
      }
      if (response.data.length === 0) {
        setAppointmentsAvailable(false);
      } else {
        setAppointmentsAvailable(true);
        const groupedData = response.data.reduce((accumulator, { time, slotsAvailable, calendarId, timeZone }) => {
          const date = time.split("T")[0];
          if (!accumulator[date]) {
            accumulator[date] = [];
          }
          accumulator[date].push({ time, slotsAvailable, calendarId, timeZone });
          return accumulator;
        }, {});
        const formattedCalendarData = Object.keys(groupedData).map((date) => ({
          date,
          slots: groupedData[date]
        }));
        const sortedDateStrings = sortAndFilterDatesAndTimes(formattedCalendarData);
        setDateRangeStart(parseAndFormatDate(sortedDateStrings[0]));
        setDateRangeEnd(parseAndFormatDate(sortedDateStrings[sortedDateStrings.length - 1], true));
      }
      if (!triggeredByPagination) {
        window.ElevarDataLayer.push({
          event: "dl_fitting_experience",
          locationName: selectedStoreName,
          loggedIn,
          fittingExperience: workTypeName
        });
      }
    } catch (error) {
      let errorType = "FrontEnd JS";
      if (axios.isAxiosError(error)) {
        if (error.response) {
          errorType = "Server Error";
        } else if (error.request) {
          errorType = "Axios/Network";
        }
      }
      const serializedError = ((_a = error.toJSON) == null ? void 0 : _a.call(error)) || {
        name: error.name,
        message: error.message,
        stack: error.stack
      };
      dataLayerErrorHandler("dl_fitting_error", "fittingExperience", errorType, JSON.stringify(serializedError));
      console.error("Error fetching calendar dates and times:", serializedError);
      window.location.href = acuityLink;
    } finally {
      if (triggeredByPagination) {
        setTransitioning(false);
      } else {
        setLoading(false);
      }
      setRefreshCalendar(false);
    }
  };
  let tempWorkTypeId;
  reactExports.useEffect(() => {
    if (refreshCalendar || workTypeId !== tempWorkTypeId) {
      fetchCalendarData(false);
      setUserPaginated(false);
      tempWorkTypeId = workTypeId;
    }
  }, [workTypeId, refreshCalendar]);
  const prevFetchedStartDatesRef = reactExports.useRef();
  reactExports.useEffect(() => {
    if (prevFetchedStartDatesRef.current && prevFetchedStartDatesRef.current.length > fetchedStartDates.length) {
      const previousPaginationFirstDateToQuery = fetchedStartDates[fetchedStartDates.length - 1];
      fetchCalendarData(true, previousPaginationFirstDateToQuery, false);
      if (fetchedStartDates.length <= 1) {
        setPreviousPaginationDisabled(true);
      }
    }
    prevFetchedStartDatesRef.current = fetchedStartDates;
  }, [fetchedStartDates]);
  reactExports.useEffect(() => {
    calendarData.forEach((_, index) => handleScroll(index));
  }, [calendarData]);
  const handleScroll = (index) => {
    const scrollingContainer = scrollContainers.current[index];
    if (!scrollingContainer) return;
    const showLeft = scrollingContainer.scrollLeft > 5;
    const showRight = scrollingContainer.scrollWidth - scrollingContainer.scrollLeft - scrollingContainer.clientWidth > 5;
    setShowLeftShadow((prev) => {
      const updated = [...prev];
      updated[index] = showLeft;
      return updated;
    });
    setShowRightShadow((prev) => {
      const updated = [...prev];
      updated[index] = showRight;
      return updated;
    });
  };
  const paginationHandler = (prevNext) => {
    scrollContainers.current.forEach((container) => {
      if (container && container.scrollLeft > 0) container.scrollLeft = 0;
    });
    if (prevNext === "next" && lastDayReturned) {
      const nextDay = new Date(lastDayReturned);
      nextDay.setDate(nextDay.getDate() + 1);
      setPreviousPaginationDisabled(false);
      setFirstDateToQuery(nextDay);
      fetchCalendarData(true, nextDay, true);
      setUserPaginated(true);
    } else if (prevNext === "prev") {
      setFetchedStartDates((prev) => prev.slice(0, prev.length - 1));
      setUserPaginated(true);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "scroll-mt-[var(--nav-height)]", ref: calendarRef, children: loading ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    LoadingIndicator,
    {
      displayedText: translations == null ? void 0 : translations.calendarSpinnerText
    }
  ) : appointmentsAvailable ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative", children: [
    transitioning && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute inset-0 z-10 flex items-center justify-center bg-white bg-opacity-60", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingIndicator, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: transitioning ? "pointer-events-none opacity-50" : "", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-center gap-x-6 md:gap-x-16 py-6", children: [
        dateRangeStart.short === dateRangeEnd.short ? /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-md order-2", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "sr-only", children: dateRangeStart.long }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: dateRangeStart.short })
        ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "order-2 h3 md:h2", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "sr-only", children: [
            dateRangeStart == null ? void 0 : dateRangeStart.long,
            " through ",
            dateRangeEnd == null ? void 0 : dateRangeEnd.long
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { "aria-hidden": "true", children: [
            dateRangeStart == null ? void 0 : dateRangeStart.short,
            " - ",
            dateRangeEnd == null ? void 0 : dateRangeEnd.short
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            onClick: () => paginationHandler("prev"),
            className: `btn btn-primary btn-lg order-1 box-content h-6 w-6 p-0 rounded-full active:bg-inherit ${previousPaginationDisabled ? "disabled button" : ""}`,
            disabled: previousPaginationDisabled,
            "aria-hidden": previousPaginationDisabled,
            ...!previousPaginationDisabled && { "aria-label": "Go to previous page" },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconChevronLeft, { size: "4" })
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            onClick: () => paginationHandler("next"),
            className: "btn btn-primary btn-lg order-3 box-content h-6 w-6 p-0 rounded-full active:bg-inherit ",
            "aria-label": "Go to next page",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconChevronRight, { size: "4" })
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row py-2.5", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col max-w-5xl gap-4 mx-auto", children: calendarData.map((dateObj, index) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("header", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("h3", { className: "font-bold pb-2 md:pb-3", children: [
          getDateFromString(dateObj.date, "day"),
          ", ",
          getDateFromString(dateObj.date, "monthDayShort")
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ShadowOverlay, { showLeft: showLeftShadow[index], showRight: showRightShadow[index] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              className: "scroll-container overflow-x-auto md:overflow-visible p-1",
              ref: (scrollingContainer) => scrollContainers.current[index] = scrollingContainer,
              onScroll: () => handleScroll(index),
              children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex md:flex-wrap gap-2 md:gap-3", children: dateObj.slots.map((slot, slotIndex) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "shrink-0 w-[120px]", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  className: `btn btn-${selectedTime === slot.time ? "primary" : "secondary"}
                                            w-[120px] rounded-md px-4 py-2.5 text-sm
                                            focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-shadow-black`,
                  onClick: () => onAppointmentSelect(slot.time, slot.calendarId, slot.timeZone),
                  children: new Date(slot.time).toLocaleTimeString(fullLocaleString, {
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: hour12Format,
                    timeZone: slot.timeZone
                  })
                }
              ) }, slotIndex)) })
            }
          )
        ] })
      ] }, index)) }) })
    ] })
  ] }) : userPaginated ? (
    // Show messaging if no appointments are available for the selected location and work type
    // If the user paginated forwarded and no availability was returned, allow them to paginate back to previously displayed dates
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center flex-col justify-center pt-5 px-3", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          onClick: () => paginationHandler("prev"),
          className: "btn btn-primary btn-lg rounded-full active:bg-inherit",
          "aria-label": "Back to previous dates",
          children: translations == null ? void 0 : translations.noAppointmentsPaginateBackButton
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-5 text-center text-sm", dangerouslySetInnerHTML: { __html: translations == null ? void 0 : translations.noAppointmentsHelpText } })
    ] })
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-5 text-center text-sm", dangerouslySetInnerHTML: { __html: translations == null ? void 0 : translations.noAppointmentsHelpText } }) });
};
const workTypeTranslations = {
  ironsFitting: {
    // en-US - 7855171
    // en-GB - 36430420
    // fr-CA - 34721173
    // en-CA - 32896711
    // ja-JP - 39968849
    ids: [7855171, 36430420, 34721173, 32896711, 39968849],
    en: {
      name: "Irons Fitting",
      description: "Fine-tune your scoring clubs with a PXG iron fitting. Our irons are a fast track to lowering your score. Explore and compare models like GEN7, 0317, and Black Ops irons."
    },
    fr: {
      name: "Les fers",
      description: "Ajuster avec précision vos fers PXG. Avec la face la plus mince de l'industrie du golf, nos fers Gen7, 0317 et black Ops sont la façon la plus facile de baisser vos pointages."
    },
    ja: {
      name: "アイアンフィッティング",
      description: "PXGのアイアンフィッティングで、スコアを伸ばすクラブを微調整しましょう。当社のアイアンは、スコアを伸ばす近道です。GEN7、0317、Black Opsアイアンなどのモデルを比較検討してください。"
    }
  },
  fullBagExperience: {
    // en-US - 34578158
    // en-GB - 33243742
    // fr-CA - 34720090
    // en-CA - 46005260
    // ja-JP - 39968821
    ids: [34578158, 33243742, 34720090, 46005260, 39968821],
    en: {
      name: "The Full Bag Experience",
      description: "Experience a data-driven fitting with a PXG Master Fitter to find the perfect clubs for your game.  Receive one-on-one time and a full analysis for driver, woods, hybrids, irons, wedges, and putters."
    },
    fr: {
      name: "Le sac complet",
      description: "Une expérience immersive, ou les données seront utilisées pour optimiser votre performance. Vous aurez accès à un Maître ajusteur PXG pour une analyse complète de tous les bois, les fers, les cocheurs et le fer droit."
    },
    ja: {
      name: "フルバッグ体験",
      description: "PXGマスターフィッターによるデータに基づくフィッティングを体験し、お客様のゲームに最適なクラブを見つけましょう。 ドライバー、フェアウェイウッド、ハイブリッド、アイアン、ウェッジ、パターの1対1のフィッティングと詳細な分析をお受けいただけます。"
    }
  },
  luckySeven: {
    // en-US - 7855193
    // en-GB - 62421161
    // fr-CA - does not exist in Acuity FR-CA Portal
    // en-CA - does not exist in Acuity EN-CA Portal
    // ja-JP - does not exist in Acuity JA-JP Portal
    ids: [7855193, 62421161],
    en: {
      name: "Lucky 7 Combination Fitting",
      description: `The "Lucky 7" fitting lets you mix and match seven GEN7 Irons, Black Ops Irons, Sugar Daddy III Wedges, or Black Ops Hybrids at an unbeatable price.`
    },
    fr: {
      name: "Lucky 7",
      description: `Le fitting "Lucky 7" vous permet de combiner sept fers GEN7, fers Black Ops, wedges Sugar Daddy III ou hybrides Black Ops à un prix imbattable.`
    },
    ja: {
      name: "ラッキー7 コンビネーションフィッティング ",
      description: "「ラッキー7」フィッティングでは、GEN7アイアン、ブラックオプスアイアン、シュガーダディIIIウェッジ、またはブラックオプスハイブリッドを7本、お好みに合わせて組み合わせることができます。"
    }
  },
  longGame: {
    // en-US - 7855185
    // en-GB - 32702137
    // fr-CA - 34721168
    // en-CA - 32896694
    // ja-JP - Japan has different work types:
    // Long game fitting in the US/UK/CA is drivers, fairways, and woods
    // In JP they have separate fitting types of "Driver Course" and "Fairway Wood and Hybrid Course"
    ids: [7855185, 32702137, 34721168, 32896694],
    en: {
      name: "Long Game Fitting",
      description: "Enhace power distance, and consistency off the tee with our long game fitting. Spend an hour with a PXG Master Fitter who will tailor the perfect driver, fairway, and hybrid setup to boost your performance."
    },
    fr: {
      name: "Le jeu long",
      description: "Ajoutez de la puissance, de la distance et soyez plus constant avec cette séance de fitting du jeu long. Vous aurez accès à un Maître ajusteur PXG pour une analyse complète de tous les bois et hybrides."
    },
    ja: {
      name: "ロングゲームフィッティング ",
      description: "ロングゲームフィッティングで飛距離とティーショットの安定性を向上させましょう。PXGマスターフィッターが、お客様のパフォーマンスを最大限に引き出す完璧なドライバー、フェアウェイ、ハイブリッドのセッティングを1時間かけてカスタマイズします。"
    }
  },
  swingSession: {
    // en-US - 41057427
    // en-GB - does not exist on Acuity UK portal
    // fr-CA - does not exist on Acuity FR-CA portal
    // en-CA - does not exist on Acuity EN-CA portal
    // ja-JP - does not exist on Acuity JA-JP portal
    ids: [41057427],
    en: {
      name: "Swing Session",
      description: "Book our 30 minute swing session to experience our line up of PXG clubs."
    },
    fr: {
      name: "Essai PXG",
      description: "Réservez un rendez-vous de 30 minutes pour essayer notre gamme complète de bâtons"
    },
    ja: {
      name: "試打会",
      description: "30分間のスイングセッションをご予約いただくと、PXGのクラブラインナップをお試しいただけます。"
    }
  },
  putterFitting: {
    // en-US - 8315940
    // en-GB - 33243742
    // fr-CA - 34721179
    // en-CA - 32896723
    // ja-JP - 51934259
    ids: [8315940, 33243742, 34721179, 32896723, 51934259],
    en: {
      name: "Putter Fitting",
      description: "Our putter fitting offers access to all our fully optimized Battle Ready II putters, available in blade to mallet head shapes. TrackMan Technology provided data showing which putter suits you best."
    },
    fr: {
      name: "Le putter",
      description: "Une séance de fitting PXG du fer droit, propulsée par la technologie Trackman, optimise parfaitement les fers droits Battle Ready 2 et le Allan. Disponible dans plusieurs styles, vous allez trouvez celui qui fonctionne le mieux pour vous."
    },
    ja: {
      name: "パターフィッティング",
      description: "当社のパターフィッティングでは、ブレード型からマレット型まで、すべて最適化されたバトル・レディIIパターのすべてをお試しいただけます。 TrackManテクノロジーにより、お客様に最適なパターのデータをご提供いたします。"
    }
  },
  specCheck: {
    // en-US - 8067288
    // en-GB - 34081734
    // fr-CA - 34721193
    // en-CA - 40435940
    // ja-JP - 56563974
    ids: [8067288, 34081734, 34721193, 40435940, 56563974],
    en: {
      name: "Spec Check - Review Existing Equipment",
      description: ""
    },
    fr: {
      name: "Vérification des spécifications - Bâtons PXG existants",
      description: ""
    },
    ja: {
      name: "スペックチェック",
      description: ""
    }
  },
  // Japan only work type - no need to translate into Japanese
  driverFittingJapan: {
    ids: [39968834],
    en: {
      name: "Driver Fitting",
      description: ""
    },
    fr: {
      name: "Bois N°1",
      description: ""
    }
  },
  // Japan only work type - no need to translate into Japanese
  fairwayWoodAndHybridFittingJapan: {
    ids: [39968841],
    en: {
      name: "Fairway Wood and Hybrid Fitting",
      description: ""
    },
    fr: {
      name: "Fairways et Hybrides",
      description: ""
    }
  },
  // Japan only work type - no need to translate into Japanese
  wedgeFittingJapan: {
    ids: [39968863],
    en: {
      name: "Wedge Fitting",
      description: ""
    },
    fr: {
      name: "Cocheurs",
      description: ""
    }
  }
};
const filterTranslations = {
  "fr-CA": {
    "PXG Store": "Magasin PXG",
    "Fitting Studio": "Studio Fitting PXG",
    "Rental Location": "Emplacement de location",
    "Certified Retailer": "Détaillant certifié",
    "Green Grass": "Partenaire"
  },
  "ja-JP": {
    "PXG Store": "PXG直営店",
    "Fitting Studio": "PXGフィッティング店舗",
    "Rental Location": "レンタル店舗",
    "Certified Retailer": "正規販売店",
    "Green Grass": "相棒"
  }
};
const phonePrefixMap = {
  "US": "+1",
  "CA": "+1",
  "GB": "+44",
  "JP": "+81",
  "IE": "+353",
  "NO": "+47",
  "SE": "+46",
  "FI": "+358",
  "EE": "+372",
  "LV": "+371",
  "PL": "+48",
  "NL": "+31",
  "BE": "+32",
  "DE": "+49",
  "SK": "+421",
  "RO": "+40",
  "BG": "+359",
  "FR": "+33",
  "IT": "+39",
  "ES": "+34",
  "PT": "+351",
  "AT": "+43",
  "LU": "+352",
  "CH": "+41"
};
const SchedulerApp = () => {
  const [selectedStoreObj, setSelectedStoreObj] = reactExports.useState({
    name: "",
    type: "",
    address: "",
    phone: ""
  });
  const [selectedStoreName, setSelectedStoreName] = reactExports.useState(null);
  const [selectedCalendarIds, setSelectedCalendarIds] = reactExports.useState(null);
  const [filteredWorkTypes, setFilteredWorkTypes] = reactExports.useState([]);
  const [addOn, setAddOn] = reactExports.useState({});
  const [selectedWorkTypeAvailableAddOns, setSelectedWorkTypeAvailableAddOns] = reactExports.useState(null);
  const [selectedWorkTypeId, setSelectedWorkTypeId] = reactExports.useState(null);
  const [selectedAppointment, setSelectedAppointment] = reactExports.useState(false);
  const [finalBookingObject, setFinalBookingObject] = reactExports.useState({});
  const [acuityLink, setAcuityLink] = reactExports.useState(null);
  const workTypesRef = reactExports.useRef(null);
  const calendarRef = reactExports.useRef(null);
  const finalBookingRef = reactExports.useRef(null);
  const [translations, setTranslations] = reactExports.useState(null);
  const [loggedInCustomerData, setLoggedInCustomerData] = reactExports.useState(null);
  const [renderScheduler, setRenderScheduler] = reactExports.useState(false);
  const [refreshCalendar, setRefreshCalendar] = reactExports.useState(false);
  const [selectedTime, setSelectedTime] = reactExports.useState(null);
  const fullLocaleString = `${Shopify.locale}-${Shopify.country}`;
  const [storeAcuityLocale, setStoreAcuityLocale] = reactExports.useState(null);
  const [fetchedStartDates, setFetchedStartDates] = reactExports.useState([]);
  const [firstDateToQuery, setFirstDateToQuery] = reactExports.useState(/* @__PURE__ */ new Date());
  window.ElevarDataLayer = window.ElevarDataLayer || [];
  const loggedIn = parseFloat(document.querySelector("#acuity-app").dataset.loggedIn);
  let hour12Format = true;
  if (fullLocaleString === "fr-CA") {
    hour12Format = false;
  }
  const mapObserver = () => {
    const interval = setInterval(() => {
      const initializeObserver = () => {
        const mapPinsWrapper = document.querySelector(".gm-style");
        if (mapPinsWrapper) {
          clearInterval(interval);
          const observer = new MutationObserver(() => {
            const childPins = mapPinsWrapper.querySelectorAll('div[tabindex="-1"]');
            if (childPins) {
              for (const pin of childPins) {
                pin.setAttribute("tabindex", "0");
              }
            }
          });
          const config = {
            childList: true,
            attributes: true,
            subtree: true,
            characterData: true
          };
          observer.observe(mapPinsWrapper, config);
          return () => {
            observer.disconnect();
          };
        }
      };
      const cleanup = initializeObserver();
      return cleanup;
    }, 500);
  };
  const workTypeTranslator = (workTypeToTranslate, userLocaleLanguage) => {
    for (const workType in workTypeTranslations) {
      if (workTypeTranslations[workType].ids.includes(workTypeToTranslate.id)) {
        workTypeToTranslate.name = workTypeTranslations[workType][userLocaleLanguage].name;
        workTypeToTranslate.description = workTypeTranslations[workType][userLocaleLanguage].description;
      }
    }
  };
  const dataLayerErrorHandler = (event, fittingStep, errorType, errorMessage) => {
    window.ElevarDataLayer.push({
      event,
      errorType,
      errorMessage,
      checkoutStepName: fittingStep,
      calendarIds: selectedCalendarIds,
      locale: storeAcuityLocale,
      ...selectedWorkTypeId && { selectedWorkTypeId }
    });
  };
  const handleFilterWorkTypes = async (storeName, storeCalendarIds) => {
    var _a;
    if (!renderScheduler) return;
    let response;
    try {
      response = await axios.post(`https://${Shopify.pxgApiEndpoint}/acuity/appointment-types`, {
        calendarIds: storeCalendarIds,
        locale: storeAcuityLocale
      });
      window.ElevarDataLayer.push({
        event: "dl_begin_fitting",
        locationName: storeName,
        loggedIn
      });
      const storeLocaleLang = storeAcuityLocale.split("_")[0];
      const userLocaleLang = fullLocaleString.split("-")[0];
      const translateWorkType = storeLocaleLang !== userLocaleLang;
      const filteredResponseWorkTypes = response.data.appointmentTypes.filter((workType) => {
        const hasMatchingCalendar = workType.calendarIds.some((id) => storeCalendarIds.includes(id));
        return hasMatchingCalendar && !workType.private;
      }).map((workType) => {
        if (translateWorkType) {
          workTypeTranslator(workType, userLocaleLang);
        }
        workType.durationUnits = userLocaleLang === "ja" ? "分" : "Min";
        return workType;
      });
      setFilteredWorkTypes(filteredResponseWorkTypes);
      let addOnIdsFromFilteredWorkTypes = /* @__PURE__ */ new Set();
      filteredResponseWorkTypes.forEach(({ addonIds }) => {
        addonIds.forEach((addonId) => addOnIdsFromFilteredWorkTypes.add(addonId));
      });
      if (response.data.appointmentAddons.length > 0) {
        setAddOn(
          response.data.appointmentAddons.find(
            (addOn2) => addOnIdsFromFilteredWorkTypes.has(addOn2.id) && !addOn2.private
          )
        );
      } else {
        setAddOn(null);
      }
      if (storeName !== selectedStoreName) {
        setSelectedWorkTypeId(null);
        setSelectedAppointment(false);
        setFetchedStartDates([]);
        setFirstDateToQuery(/* @__PURE__ */ new Date());
      }
      setSelectedCalendarIds(storeCalendarIds);
      setSelectedStoreName(storeName);
      setTimeout(() => {
        var _a2;
        (_a2 = workTypesRef.current) == null ? void 0 : _a2.scrollIntoView({ behavior: "smooth" });
      });
    } catch (error) {
      let errorType = "FrontEnd JS";
      if (axios.isAxiosError(error)) {
        if (error.response) {
          errorType = "Server Error";
        } else if (error.request) {
          errorType = "Axios/Network";
        }
      }
      const serializedError = ((_a = error.toJSON) == null ? void 0 : _a.call(error)) || {
        name: error.name || "Unknown error name",
        message: error.message || "Unknown error message",
        stack: error.stack || "Unknown error message"
      };
      dataLayerErrorHandler("dl_fitting_error", "beginFitting", errorType, JSON.stringify(serializedError));
      console.error("Error fetching work types:", serializedError);
      window.location.href = acuityLink;
    }
  };
  reactExports.useEffect(() => {
    mapObserver();
  }, []);
  reactExports.useEffect(() => {
    const customerObjectElement = document.querySelector("#customer-object");
    if (!customerObjectElement) return;
    try {
      const data = JSON.parse(customerObjectElement.textContent);
      if (data && Object.keys(data).length > 0) {
        setLoggedInCustomerData(data);
      }
    } catch (err) {
      console.error("Invalid customer JSON:", err);
    }
  }, []);
  reactExports.useEffect(() => {
    const data = JSON.parse(document.querySelector("#acuity-app-translations").textContent);
    setTranslations(data);
  }, []);
  reactExports.useEffect(() => {
    if (renderScheduler && selectedStoreObj.name && selectedCalendarIds) {
      handleFilterWorkTypes(selectedStoreObj.name, selectedCalendarIds);
    }
  }, [renderScheduler, selectedStoreObj.name, selectedCalendarIds]);
  const formatTelNoforHref = (number, storeCountry) => {
    let strippedNumber = number.replace(/\D/g, "");
    if (!["US", "CA", "LU"].includes(storeCountry) && strippedNumber.charAt(0) === "0") {
      strippedNumber = strippedNumber.slice(1);
    }
    let localePhonePrefix = "+1";
    if (storeCountry && Object.keys(phonePrefixMap).includes(storeCountry)) {
      localePhonePrefix = phonePrefixMap[storeCountry];
    }
    return `tel:${localePhonePrefix + strippedNumber}`;
  };
  window.startFittingFlow = () => {
    const preSelectedStoreBookFittingButton = document.querySelector(".storerocket-result-button");
    if (preSelectedStoreBookFittingButton) {
      preSelectedStoreBookFittingButton.click();
    }
  };
  window.bookAcuityFitting = async (data, selectedElement) => {
    const isOverlaySelected = selectedElement.classList.contains("storerocket-overlay-details-custom-ctas-item");
    const parentElement = isOverlaySelected ? selectedElement.parentElement.parentElement.parentElement : selectedElement.parentElement.parentElement;
    const baseSelector = isOverlaySelected ? ".storerocket-overlay-details" : ".storerocket-result";
    const storeName = parentElement.querySelector(`${baseSelector}-name`).textContent.trim();
    let addressLineOne;
    let addressCountry;
    if (isOverlaySelected) {
      addressLineOne = parentElement.querySelector(`${baseSelector}-address-line1`).textContent.trim();
      addressCountry = parentElement.querySelector(`${baseSelector}-address-country`).textContent.trim();
    } else {
      addressLineOne = parentElement.querySelector(`${baseSelector}-address-line-1`).textContent.trim();
      addressCountry = parentElement.querySelector(`${baseSelector}-country`).textContent.trim();
    }
    const addressCity = parentElement.querySelector(`${baseSelector}-address-city`).textContent.trim();
    const addressPostCode = parentElement.querySelector(`${baseSelector}-address-postcode`).textContent.trim();
    let addressStatePostCode;
    if (parentElement.querySelector(`${baseSelector}-address-state`)) {
      addressStatePostCode = `${parentElement.querySelector(`${baseSelector}-address-state`).textContent.trim()} ${addressPostCode}`;
    } else {
      addressStatePostCode = addressPostCode;
    }
    const storeAddress = `${addressLineOne}, ${addressCity}, ${addressStatePostCode}`;
    let storePhone = "";
    if (!isOverlaySelected) {
      if (parentElement.querySelector(".storerocket-result-phone")) {
        storePhone = parentElement.querySelector(".storerocket-result-phone").textContent.trim();
      }
    } else if (parentElement.querySelector(".storerocket-overlay-details-action-button")) {
      storePhone = parentElement.querySelector(".storerocket-overlay-details-action--phone").querySelector("a").textContent.trim();
    }
    const hrefFormattedPhoneNumber = formatTelNoforHref(storePhone, addressCountry);
    setAcuityLink(data.link);
    if (data.locale) {
      setStoreAcuityLocale(data.locale);
    }
    setRenderScheduler(true);
    setSelectedCalendarIds(data.calendarIds);
    setSelectedStoreObj({
      name: storeName,
      address: storeAddress,
      phone: storePhone,
      hrefFormattedPhoneNumber
    });
    setTimeout(() => {
      var _a;
      (_a = workTypesRef.current) == null ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
    }, 500);
    if (window.featureToggle.preferredStoreUXEnabled && storeName !== "PXG Phone Fitting") {
      const queryParam = encodeURIComponent(storeName);
      let pxgMatchedStore;
      try {
        const newMatchedStoreResponse = await fetch(
          `/apps/pxg/v1/store-detail?name=${queryParam}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        );
        if (!newMatchedStoreResponse.ok) {
          throw new Error(`Request failed: ${newMatchedStoreResponse.status}`);
        }
        const data2 = await newMatchedStoreResponse.json();
        pxgMatchedStore = data2.store;
      } catch (error) {
        console.error("Error fetching store:", error);
      }
      if (window.setStoreCookie && window.updateLocationUI) {
        window.setStoreCookie({
          name: pxgMatchedStore.name,
          latitude: pxgMatchedStore.lat,
          longitude: pxgMatchedStore.lng
        });
        window.updateLocationUI(pxgMatchedStore.name, pxgMatchedStore.lat, pxgMatchedStore.lng);
      }
    }
  };
  let filterActivated;
  window.filterOptionsTranslateAndPreSelect = (element, urlParamFilters) => {
    let preSelectedFilters;
    if (urlParamFilters) {
      preSelectedFilters = urlParamFilters.split(",");
    } else {
      if (Shopify.country === "CA" || Shopify.country === "GB") {
        preSelectedFilters = ["139823", "139817", "139821"];
      } else {
        preSelectedFilters = ["139823", "139817"];
      }
    }
    let doTranslate = !!(filterTranslations == null ? void 0 : filterTranslations[fullLocaleString]);
    const filterOptions = element.querySelectorAll(".storerocket-overlay-list-item-name");
    filterOptions.forEach((item) => {
      if (doTranslate) {
        item.textContent = filterTranslations[fullLocaleString][item.textContent.trim()];
      }
      if (preSelectedFilters.includes(item.parentElement.dataset.filter)) {
        item.parentElement.classList.add("is-active");
        filterActivated = true;
      }
    });
    if (document.querySelector(".storerocket-map-switch-units-kilometers") && (Shopify.country === "JP" || Shopify.country === "CA")) {
      document.querySelector(".storerocket-map-switch-units-kilometers").click();
    }
  };
  window.storeCardLocalization = (element) => {
    if (element.classList.contains("storerocket-overlay-filters-item")) {
      const storeCountry = element.parentElement.parentElement.parentElement.querySelector(".storerocket-overlay-details-address-country").textContent.trim();
      const phoneLink = element.parentElement.parentElement.querySelector(".storerocket-overlay-details-action--phone").querySelector("a");
      if (phoneLink) {
        let currentHref = phoneLink.getAttribute("href");
        let updatedHref = formatTelNoforHref(currentHref, storeCountry);
        phoneLink.setAttribute("href", updatedHref);
      }
    }
    if (!filterTranslations[fullLocaleString]) return;
    element.textContent = filterTranslations[fullLocaleString][element.textContent.trim()];
  };
  window.ctaTranslatorAndFilterApply = (element) => {
    if (filterActivated) {
      document.querySelector(".storerocket-overlay-filters-apply-button").click();
      filterActivated = false;
    }
    if (!filterTranslations[fullLocaleString]) return;
    if (element.textContent.includes("BOOK A FITTING")) {
      if (fullLocaleString === "fr-CA") {
        element.textContent = "RÉSERVEZ VOTRE AJUSTEMENT SUR MESURE";
      } else if (fullLocaleString === "ja-JP") {
        element.textContent = "フィッティング予約";
      }
    } else if (element.textContent.includes("STORE DETAILS")) {
      if (fullLocaleString === "fr-CA") {
        element.textContent = "DÉTAILS SUR LE MAGASIN";
      } else if (fullLocaleString === "ja-JP") {
        element.textContent = "店舗詳細";
      }
    }
  };
  const handleWorkTypeSelection = (workType) => {
    setSelectedWorkTypeId(workType.id);
    setSelectedWorkTypeAvailableAddOns(workType.addonIds);
    setSelectedTime(null);
    setSelectedAppointment(false);
    setFetchedStartDates([]);
    setFirstDateToQuery(/* @__PURE__ */ new Date());
    setFinalBookingObject((prevState) => ({
      ...prevState,
      appointmentTypeId: workType.id,
      workTypeName: workType.name,
      workType: {
        name: workType.name,
        description: workType.description,
        duration: workType.duration
      }
    }));
    setTimeout(() => {
      var _a;
      (_a = calendarRef.current) == null ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
    }, 500);
  };
  const handleAppointmentSelect = (slotTime, slotCalendarId, slotTimeZone) => {
    setSelectedAppointment(true);
    setFinalBookingObject((prevState) => ({
      ...prevState,
      dateTime: slotTime,
      dateTimeReadable: getDateFromIso(slotTime, "fullDateTime", false, slotTimeZone),
      calendarId: slotCalendarId
    }));
    setSelectedTime(slotTime);
    setTimeout(() => {
      var _a;
      (_a = finalBookingRef.current) == null ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
    }, 500);
    window.ElevarDataLayer.push({
      event: "dl_select_appointment",
      locationName: selectedStoreName,
      loggedIn,
      fittingExperience: finalBookingObject.workTypeName,
      appointmentDate: getDateFromIso(slotTime, "fullDateTime", false, slotTimeZone)
    });
  };
  const bookAnotherAppointmentHandler = (bookingSuccess) => {
    setSelectedAppointment(null);
    if (bookingSuccess) {
      setSelectedWorkTypeId(null);
      setFetchedStartDates([]);
      setFirstDateToQuery(/* @__PURE__ */ new Date());
      setTimeout(() => {
        var _a;
        (_a = workTypesRef.current) == null ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
      });
    } else {
      setTimeout(() => {
        var _a;
        (_a = calendarRef.current) == null ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
      });
      setRefreshCalendar(true);
    }
  };
  if (!renderScheduler || filteredWorkTypes.length === 0) {
    return null;
  }
  const capitalizeFirstLetters = (str) => {
    const capitalizedString = str.split(" ").map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return capitalizedString.join(" ");
  };
  const getDateFromIso = (dateInput, type, bypassDateSetup = false, timeZone) => {
    const date = bypassDateSetup ? dateInput : new Date(dateInput);
    let returnString;
    switch (type) {
      case "day":
        returnString = date.toLocaleDateString(fullLocaleString, { weekday: "long" });
        break;
      case "shortDay":
        returnString = date.toLocaleDateString(fullLocaleString, { weekday: "short" });
        break;
      case "month":
        returnString = date.toLocaleDateString(fullLocaleString, { month: "long" });
        break;
      case "shortMonth":
        returnString = date.toLocaleDateString(fullLocaleString, { month: "short" });
        break;
      case "monthDayShort":
        returnString = date.toLocaleDateString(fullLocaleString, { month: "short", day: "numeric" });
        break;
      case "fullDateTime":
        const options = {
          weekday: "long",
          month: "long",
          day: "numeric"
        };
        let returnDate = date.toLocaleDateString(fullLocaleString, options);
        if (fullLocaleString === "fr-CA") {
          returnDate = capitalizeFirstLetters(returnDate);
        }
        const returnTime = date.toLocaleTimeString(fullLocaleString, {
          hour: "numeric",
          minute: "2-digit",
          hour12: hour12Format,
          timeZone
        });
        returnString = `${returnDate} - ${returnTime}`;
        break;
      default:
        returnString = date.toLocaleDateString(fullLocaleString, { month: "long", day: "numeric" });
        break;
    }
    if (fullLocaleString === "fr-CA" && type !== "fullDateTime") {
      returnString = capitalizeFirstLetters(returnString);
    }
    return returnString;
  };
  const getDateFromString = (dateString, type = null) => {
    const [year, month, day] = dateString.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    return getDateFromIso(date, type, true);
  };
  function changeLocationHandler() {
    var _a, _b;
    let storerocketSingleStoreUI = false;
    const storeRocketOverlay = document.querySelector("#storerocket-overlay");
    if (storeRocketOverlay.classList.contains("is-open")) {
      storeRocketOverlay.classList.remove("is-open", "is-visible");
      storerocketSingleStoreUI = true;
    }
    const params = new URLSearchParams(window.location.search);
    if (params.has("location")) {
      storerocketSingleStoreUI = true;
    }
    const clearBtn = document.querySelector(".storerocket-clear-search");
    if (clearBtn && clearBtn.offsetParent !== null) {
      clearBtn.click();
    }
    (_a = document.querySelector("#storerocket-map-container button.gm-ui-hover-effect")) == null ? void 0 : _a.click();
    if (storerocketSingleStoreUI) {
      const searchInputField = document.querySelector(".storerocket-search-field");
      searchInputField.value = selectedStoreObj.address;
      const enterEvent = new KeyboardEvent("keydown", {
        bubbles: true,
        cancelable: true,
        key: "Enter",
        code: "Enter",
        keyCode: 13
      });
      searchInputField.dispatchEvent(enterEvent);
    }
    const mapScrollToId = document.querySelector("#locations-component");
    if (mapScrollToId) {
      mapScrollToId.scrollIntoView({ behavior: "smooth" });
    }
    (_b = window.ElevarDataLayer) == null ? void 0 : _b.push({
      event: "dl_change_location",
      locationName: selectedStoreName,
      loggedIn
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex scroll-mt-[var(--nav-height)] justify-center", ref: workTypesRef, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        onClick: changeLocationHandler,
        className: "btn-secondary rounded-b-lg rounded-t-none border-t-0 px-4 py-2",
        children: translations == null ? void 0 : translations.switchLocationButtonText
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "container-fluid-max py-6 lg:py-10", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        WorkTypes,
        {
          translations,
          filteredWorkTypes,
          onWorkTypeSelect: handleWorkTypeSelection,
          selectedWorkTypeId,
          selectedStoreName: selectedStoreObj.name,
          loggedIn,
          selectedStoreObj
        }
      ),
      selectedWorkTypeId && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Calendar,
        {
          calendarRef,
          translations,
          workTypeId: selectedWorkTypeId,
          calendarIds: selectedCalendarIds,
          onAppointmentSelect: handleAppointmentSelect,
          refreshCalendar,
          setRefreshCalendar,
          selectedTime,
          getDateFromString,
          acuityLink,
          fullLocaleString,
          storeAcuityLocale,
          hour12Format,
          capitalizeFirstLetters,
          selectedStoreName,
          loggedIn,
          workTypeName: finalBookingObject.workTypeName,
          dataLayerErrorHandler,
          fetchedStartDates,
          setFetchedStartDates,
          firstDateToQuery,
          setFirstDateToQuery
        }
      ),
      selectedAppointment && /* @__PURE__ */ jsxRuntimeExports.jsx(
        FinalBooking,
        {
          selectedStoreObj,
          finalBookingObject,
          finalBookingRef,
          bookAnotherAppointmentHandler,
          selectedTime,
          acuityLink,
          translations,
          storeAcuityLocale,
          loggedIn,
          dataLayerErrorHandler,
          addOn,
          selectedWorkTypeAvailableAddOns,
          selectedCalendarIds,
          loggedInCustomerData
        }
      )
    ] })
  ] });
};
const fittingAppMountingElement = document.getElementById("acuity-app");
if (fittingAppMountingElement) {
  const root = clientExports.createRoot(fittingAppMountingElement);
  root.render(
    /* @__PURE__ */ jsxRuntimeExports.jsx(React.StrictMode, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SchedulerApp, {}) })
  );
}
